import { registerLocaleData, DOCUMENT } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import * as i0 from '@angular/core';
import { InjectionToken, LOCALE_ID, NgModule, inject, Injectable, Inject } from '@angular/core';
import * as i2 from '@angular/common/http';
import { HttpHeaders, HttpParams, HttpErrorResponse, HttpClient } from '@angular/common/http';
import { Subject, of, from, Observable, forkJoin, throwError, lastValueFrom, map as map$1, finalize, ReplaySubject, BehaviorSubject, concatAll, mergeMap as mergeMap$1 } from 'rxjs';
import { tap, mergeMap, mapTo, catchError, publishLast, refCount, takeUntil, map, last, concatMap } from 'rxjs/operators';
import { JwtHelperService } from '@auth0/angular-jwt';
import * as i1 from 'ngx-cookie-service';
import { CookieService } from 'ngx-cookie-service';
import { CartModel, ProductFactory, Insurance, Edp, Phone, Fai, Accessory, Delivery, Plan, QuoteContextRenewalModel as QuoteContextRenewalModel$1, RENEW_NB_TERMS, QuoteContextAcquisitionModel, QuoteContextFaiModel, QUOTE_CONTEXTS as QUOTE_CONTEXTS$1, RENEW_CLIENT_TYPES, Sowo, PromotionModel, PromotionsModel, QuoteModel, PRICE_TYPES as PRICE_TYPES$1, Sensation, Option, Product, REDUCTION_TYPE, ACCESS_TYPE, CartService, FaimUnlimited, Simo } from '@bytel/bytel-sales';
import { differenceInDays, addDays } from 'date-fns';
import { v4 } from 'uuid';
const OPTIONS_CONFIG = new InjectionToken('OPTIONS_CONFIG');
registerLocaleData(localeFr);
let CheckoutModule = /*#__PURE__*/(() => {
  class CheckoutModule {
    static forRoot(optionsConfig) {
      return {
        ngModule: CheckoutModule,
        providers: [{
          provide: OPTIONS_CONFIG,
          useValue: optionsConfig
        }, {
          provide: LOCALE_ID,
          useValue: 'fr-FR'
        }]
      };
    }
    static ɵfac = function CheckoutModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CheckoutModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CheckoutModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return CheckoutModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class Oauth2IframeClass {
  static injectIframe(src) {
    const iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.sandbox = 'allow-scripts allow-same-origin';
    iframe.scrolling = 'no';
    iframe.style.display = 'none';
    document.querySelector('body').appendChild(iframe);
    return iframe;
  }
  static removeEl(node) {
    document.querySelector('body').removeChild(node);
  }
}
let CookieStorageService = /*#__PURE__*/(() => {
  class CookieStorageService extends CookieService {
    length = 1;
    dom = inject(DOCUMENT);
    clear() {
      // intentional
    }
    getItem(key) {
      return this.get(key);
    }
    key() {
      return null;
    }
    removeItem(key) {
      return this.delete(key, '/');
    }
    setItem(key, value, expires = null, path = '/', domain = `${this.dom.location.hostname.replace(/^www\./, '')}`, secure = true) {
      //const cookieDomain = this._isLocalhost(domain) ? null : domain;
      return this.set(key, value, expires, path);
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵCookieStorageService_BaseFactory;
      return function CookieStorageService_Factory(__ngFactoryType__) {
        return (ɵCookieStorageService_BaseFactory || (ɵCookieStorageService_BaseFactory = i0.ɵɵgetInheritedFactory(CookieStorageService)))(__ngFactoryType__ || CookieStorageService);
      };
    })();
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CookieStorageService,
      factory: CookieStorageService.ɵfac,
      providedIn: 'root'
    });
  }
  return CookieStorageService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Oauth2StorageService = /*#__PURE__*/(() => {
  class Oauth2StorageService {
    cookie;
    KEY = {
      STATE: 'state',
      NONCE: 'nonce',
      ACCESS_TOKEN: 'access_token',
      ID_TOKEN: 'id_token',
      CONTRACT_ID: 'contract_id',
      CUSTOMER: 'customer',
      CONTRACTS_INFOS: 'contracts_infos',
      PARAMS: 'params'
    };
    prefix = 'oauth2_';
    constructor(cookie) {
      this.cookie = cookie;
    }
    clear(storageInstance) {
      if (storageInstance instanceof Storage) {
        this.clearAllPrefix(storageInstance);
      } else {
        this.clearAllPrefix(sessionStorage);
        this.clearAllPrefix(localStorage);
      }
    }
    /**
     * Return item from storage
     * If expiresTimestamp is not null and lower then Now remove item and returns null
     */
    getItem(key) {
      return this._getStorageInstance().getItem(this.prefix + key);
    }
    removeItem(key) {
      this._getStorageInstance().removeItem(this.prefix + key);
    }
    /**
     * Use item of StorageInterface instead of simple key value to make storage expires
     */
    setItem(key, value, expires = null) {
      this.removeItem(key);
      this._getStorageInstance().setItem(this.prefix + key, value, expires);
    }
    /**
     * Use item of StorageInterface instead of simple key value to make storage expires
     */
    setUniversalItem(key, value, expires = null, preserveCompatibility = true) {
      const storageObject = {
        data: value,
        expiresTimestamp: expires
      };
      this.removeItem(key);
      this._getStorageInstance().setItem(this.prefix + key, JSON.stringify(preserveCompatibility ? value : storageObject));
    }
    _getStorageInstance() {
      return this.cookie;
    }
    clearAllPrefix(storageInstance) {
      const keys = Object.keys(storageInstance);
      keys.forEach(key => {
        if (key.startsWith(this.prefix)) {
          storageInstance.removeItem(key);
        }
      });
    }
    static ɵfac = function Oauth2StorageService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || Oauth2StorageService)(i0.ɵɵinject(CookieStorageService));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: Oauth2StorageService,
      factory: Oauth2StorageService.ɵfac,
      providedIn: 'root'
    });
  }
  return Oauth2StorageService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// @dynamic
let Oauth2Service = /*#__PURE__*/(() => {
  class Oauth2Service {
    document;
    cookie;
    oauth2Storage;
    httpClient;
    initialConfig;
    static CLIENT_ID = 'magento.web.bouyguestelecom.fr';
    subjectLogout = new Subject();
    subjectLogin = new Subject();
    _id_token = '';
    access_token = '';
    isConnected = false;
    jwtPayload;
    keyStorage = 'LAST_PARAMS';
    playLoad;
    afterLogout = this.subjectLogout.asObservable();
    afterLogin = this.subjectLogin.asObservable();
    CLIENT_ID = '';
    URL_BASE = '';
    COOKIE_SSO = 'SSO_ACTIVE';
    DETECT_KEY_ERROR = 'error';
    DETECT_KEY_SUCCESS = 'access_token=';
    NONCE_STATE_LENGTH = 32;
    REPONSE_TYPE = 'id_token token';
    URL_AUTHORIZE = '/authorize';
    REACT_OAUTH_KEY = 'react-oauth';
    _initialConfig;
    constructor(document, cookie, oauth2Storage, httpClient, initialConfig) {
      this.document = document;
      this.cookie = cookie;
      this.oauth2Storage = oauth2Storage;
      this.httpClient = httpClient;
      this.initialConfig = initialConfig;
      this._initialConfig = initialConfig();
      this.URL_BASE = this._initialConfig.oauth.baseUrl;
      // Init value
      this._init();
    }
    get id_token() {
      return this._id_token;
    }
    set id_token(data) {
      this._id_token = data;
      if (data) {
        const jwtHelper = new JwtHelperService();
        this.jwtPayload = jwtHelper.decodeToken(data);
        this.subjectLogin.next(this.jwtPayload);
        this.oauth2Storage.setItem(this.oauth2Storage.KEY.ID_TOKEN, data);
        this.oauth2Storage.setItem(this.oauth2Storage.KEY.PARAMS, JSON.stringify({
          aud: Oauth2Service.CLIENT_ID,
          iss: this.URL_BASE
        }));
      } else {
        this.oauth2Storage.removeItem(this.oauth2Storage.KEY.ID_TOKEN);
      }
    }
    /**
     * Check if you have SSO_ACTIVE in cookie and start redirect to Picasso
     */
    autoLogin(login = false) {
      const jwtHelper = new JwtHelperService();
      return of(true).pipe(tap(() => {
        this.initToken();
      }), mergeMap(() => {
        if (!jwtHelper.isTokenExpired(this.getTokenId())) {
          return from([true]);
        } else if (this.loggedPicasso() || this._isNextAuthCookieExist() || this._isNextSessionCookieExist()) {
          return this.loginIframeOauth2();
        } else if (login) {
          this.redirectToAuthorize();
        }
        return of(false);
      }));
    }
    redirectToAuthorize() {
      this.document.defaultView.location.href = this.getAuthorizeUrl();
    }
    getTokenId() {
      return this.oauth2Storage.getItem(this.oauth2Storage.KEY.ID_TOKEN);
    }
    getAccessToken() {
      return this.oauth2Storage.getItem(this.oauth2Storage.KEY.ACCESS_TOKEN);
    }
    initToken() {
      this._useToken(window.location.hash);
    }
    /**
     * Generate URL Authorize
     */
    getAuthorizeUrl(redirect = window.document.location.href.replace(window.location.search, ''), prompt = false) {
      const baseUrl = this.URL_BASE;
      const clientId = `client_id=${Oauth2Service.CLIENT_ID}`;
      const state = `state=${this._getNewState()}`;
      const nonce = `nonce=${this._getNewNonce()}`;
      const responseType = `response_type=${encodeURI(this.REPONSE_TYPE)}`;
      const redirectUri = `redirect_uri=${encodeURI(redirect)}`;
      const url = `${baseUrl}${this.URL_AUTHORIZE}?${clientId}&${state}&${nonce}&${responseType}&${redirectUri}`;
      return prompt ? `${url}&prompt=none` : url;
    }
    getPersonInfo() {
      return this.jwtPayload || null;
    }
    loggedPicasso() {
      return !!this.cookie.get(this.COOKIE_SSO);
    }
    /**
     * Automatically logs user with TGTID
     */
    loginWithTgtId(tgtId) {
      const serviceUrl = `${this._initialConfig.picasso.emptycallBackUrl}?callback=JSONP_CALLBACK`;
      const url = `${this._initialConfig.picasso.loginUrl}?tgtId=${tgtId}&service=${serviceUrl}`;
      return this.httpClient.jsonp(url, 'callback');
    }
    logout() {
      this.oauth2Storage.clear();
      const isProd = this._initialConfig.environment.toLowerCase() === 'PROD';
      this.cookie.delete(this.COOKIE_SSO, '/', '.bouyguestelecom.fr', isProd, isProd ? 'None' : 'Lax');
      this.access_token = null;
      this.id_token = null;
      this.isConnected = false;
      this.subjectLogout.next();
    }
    resolve(route) {
      const params = route.queryParams;
      if (Object.keys(params).length > 0) {
        const date = new Date().getTime() + 5 * 60 * 1000;
        this.oauth2Storage.setUniversalItem(this.keyStorage, JSON.stringify(params), date);
      }
      return this.autoLogin();
    }
    updateIsConnected() {
      const jwtHelper = new JwtHelperService();
      this.isConnected = !jwtHelper.isTokenExpired(this.getTokenId());
      return this.isConnected;
    }
    login(redirectUrl = this.document.defaultView.location.href) {
      if (this.loggedPicasso()) {
        return this.loginIframeOauth2();
      } else {
        this.document.defaultView.location.href = this.getAuthorizeUrl(redirectUrl);
      }
      return of(false);
    }
    /**
     * Retirec to Picasso
     */
    loginIframeOauth2() {
      return new Observable(obs => {
        let errorIframe = true;
        let oauthIframe = null;
        setTimeout(() => {
          if (!errorIframe) {
            return;
          }
          obs.error('Connexion impossible 2');
          obs.complete();
        }, 4000);
        window.addEventListener('message', e => {
          errorIframe = false;
          if (!oauthIframe || e.source !== oauthIframe.contentWindow) {
            return;
          }
          const data = e?.data || '';
          if (this._useToken(data)) {
            this.updateIsConnected();
            obs.next(true);
          } else {
            if (!this._detectTokenError(this.document.defaultView.location.href)) {
              this.document.defaultView.location.href = this.getAuthorizeUrl();
              obs.error('Connexion impossible 3');
            } else {
              this.document.defaultView.location.href = this._initialConfig.oauth.failureUrl;
            }
          }
          window.removeEventListener('message', () => {});
          obs.complete();
        }, false);
        oauthIframe = Oauth2IframeClass.injectIframe(this.getAuthorizeUrl(`${this.document.location.origin}/oauth2.html`, true));
      });
    }
    _getReactTokenInfos(key) {
      const tokenInfos = JSON.parse(localStorage.getItem(this.REACT_OAUTH_KEY));
      return tokenInfos ? tokenInfos[key] : null;
    }
    /**
     * Check if hash is error response
     */
    _detectTokenError(hash) {
      return hash.includes(this.DETECT_KEY_ERROR);
    }
    /**
     * Check if hash is success response
     */
    _detectTokenSuccess(hash) {
      return hash.includes(this.DETECT_KEY_SUCCESS);
    }
    /**
     * Remove '#/'
     * Extract param from oauth hash
     */
    _extractParam(hash) {
      const tab = hash.split('&');
      const obj = {};
      for (let i = 0; i < tab.length; i++) {
        tab[i] = tab[i].replace('#', '');
        tab[i] = tab[i].replace('/', '');
        tab[i] = tab[i].replace('?', '');
        const keyValue = tab[i].split('=');
        obj[keyValue[0]] = keyValue[1];
      }
      return obj;
    }
    /**
     * Generate key chaine and set in oauth2Storage for check after redirection
     */
    _getNewNonce() {
      const currentNonce = this._getNonce();
      if (currentNonce) {
        return currentNonce;
      }
      const nonce = this._makeNonceOrState();
      this.oauth2Storage.setItem(this.oauth2Storage.KEY.NONCE, nonce);
      return nonce;
    }
    /**
     * Generate key chaine and set in oauth2Storage for check after redirection
     */
    _getNewState() {
      const currentState = this._getState();
      if (currentState) {
        return currentState;
      }
      const state = this._makeNonceOrState();
      this.oauth2Storage.setItem(this.oauth2Storage.KEY.STATE, state);
      return state;
    }
    /**
     * State from storage
     */
    _getNonce() {
      return this.oauth2Storage.getItem(this.oauth2Storage.KEY.NONCE);
    }
    /**
     * State from storage
     */
    _getState() {
      return this.oauth2Storage.getItem(this.oauth2Storage.KEY.STATE);
    }
    _init() {
      const jwtHelper = new JwtHelperService();
      const idToken = this.getTokenId();
      this.jwtPayload = jwtHelper.decodeToken(idToken);
      this._useToken(window.location.hash);
    }
    /**
     * Generate key chaine for State
     */
    _makeNonceOrState() {
      let text = '';
      const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      for (let i = 0; i < this.NONCE_STATE_LENGTH; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      return text;
    }
    _useToken(hash) {
      if (this._detectTokenSuccess(hash)) {
        // Succes oauth redirect
        const oauthParams = this._extractParam(hash);
        if (oauthParams.state === this._getState()) {
          const jwtHelper = new JwtHelperService();
          if (jwtHelper.isTokenExpired(oauthParams.id_token)) {
            return false;
          }
          this.oauth2Storage.setItem(this.oauth2Storage.KEY.ACCESS_TOKEN, oauthParams.access_token);
          this.oauth2Storage.setItem(this.oauth2Storage.KEY.ID_TOKEN, oauthParams.id_token);
          this.access_token = oauthParams.access_token;
          this.id_token = oauthParams.id_token;
          return true;
        }
      } else if (this._detectTokenError(hash)) {
        // Error oauth redirect
        this.document.defaultView.location.href = this._initialConfig.oauth.failureUrl;
        return false;
      } else if (this.getTokenId()) {
        // Load from storage
        this.access_token = this.getAccessToken();
        this.id_token = this.getTokenId();
      }
      return false;
    }
    _isNextAuthCookieExist() {
      return !!this.cookie.get('next-auth');
    }
    _isNextSessionCookieExist() {
      return !!this.cookie.get('next-session-token');
    }
    static ɵfac = function Oauth2Service_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || Oauth2Service)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i1.CookieService), i0.ɵɵinject(Oauth2StorageService), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(OPTIONS_CONFIG));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: Oauth2Service,
      factory: Oauth2Service.ɵfac,
      providedIn: 'root'
    });
  }
  return Oauth2Service;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// @dynamic
let ConfigurationService = /*#__PURE__*/(() => {
  class ConfigurationService {
    http;
    oauth2Service;
    optionConfig;
    baseConfig;
    _data = {};
    _storageKey = 'configurations';
    _initialConfig;
    constructor(http, oauth2Service, optionConfig) {
      this.http = http;
      this.oauth2Service = oauth2Service;
      this.optionConfig = optionConfig;
      this.baseConfig = optionConfig();
      this._initialConfig = optionConfig();
    }
    getData() {
      return this._data;
    }
    getConfig() {
      return this._initialConfig;
    }
    initialize(configurations) {
      let configObs;
      if (configurations) {
        this._data = configurations;
        configObs = of(this._data);
      } else {
        configObs = this._getConfigurations();
      }
      return configObs.pipe(mapTo(this._data));
    }
    _getConfigurations() {
      const configURL = `${this._initialConfig.oauth.resourceUrl}/ventes/configuration`;
      const headers = {
        'Content-Type': 'application/json',
        'x-version': this._initialConfig.oauth.salesApiVersion || '4'
      };
      if (this._initialConfig.environment !== 'PROD' && this._initialConfig.environment !== 'LOCAL') {
        headers['X-banc'] = this._initialConfig.oauth.xBanc;
      }
      const httpOptions = {
        headers: new HttpHeaders(headers)
      };
      const configObs = this.http.get(configURL, httpOptions).pipe(tap(data => this._data = data));
      return configObs.pipe(catchError(error => {
        if (error.status === 401) {
          return this.oauth2Service.login().pipe(mergeMap(() => configObs));
        }
        throw error;
      }));
    }
    static ɵfac = function ConfigurationService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ConfigurationService)(i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(Oauth2Service), i0.ɵɵinject(OPTIONS_CONFIG));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ConfigurationService,
      factory: ConfigurationService.ɵfac,
      providedIn: 'root'
    });
  }
  return ConfigurationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class CheckoutError extends Error {
  errorThrown = true;
  constructor(message) {
    super();
    this.message = message;
  }
}
class PartnerError extends CheckoutError {
  errorThrown = false;
  name = 'partner_error';
}
var USER_TYPE_API = /*#__PURE__*/function (USER_TYPE_API) {
  USER_TYPE_API["CLIENT"] = "CLIENT";
  USER_TYPE_API["CDC"] = "CDC";
  return USER_TYPE_API;
}(USER_TYPE_API || {});
var OPTION_STATUS = /*#__PURE__*/function (OPTION_STATUS) {
  OPTION_STATUS["SUBSCRIBED"] = "SOUSCRITE";
  return OPTION_STATUS;
}(OPTION_STATUS || {});
var DISCOUNT_TYPE = /*#__PURE__*/function (DISCOUNT_TYPE) {
  DISCOUNT_TYPE["FIXED"] = "FIXE";
  DISCOUNT_TYPE["PERCENT"] = "POURCENTAGE";
  return DISCOUNT_TYPE;
}(DISCOUNT_TYPE || {});
var API_PROMO_TYPE = /*#__PURE__*/function (API_PROMO_TYPE) {
  API_PROMO_TYPE["MANUAL"] = "MANUAL";
  API_PROMO_TYPE["AUTOMATIC"] = "AUTOMATIC";
  API_PROMO_TYPE["COUPON"] = "COUPON";
  API_PROMO_TYPE["CPU"] = "CPU";
  return API_PROMO_TYPE;
}(API_PROMO_TYPE || {});
var DISPONIBILITY_SLOTS = /*#__PURE__*/function (DISPONIBILITY_SLOTS) {
  DISPONIBILITY_SLOTS["morning"] = "MATIN";
  DISPONIBILITY_SLOTS["afternoon"] = "APRES_MIDI";
  DISPONIBILITY_SLOTS["evening"] = "SOIR";
  DISPONIBILITY_SLOTS["weekend"] = "WEEK_END";
  return DISPONIBILITY_SLOTS;
}(DISPONIBILITY_SLOTS || {});
/* ENUM */
var CART_TYPES = /*#__PURE__*/function (CART_TYPES) {
  CART_TYPES["WEB"] = "web";
  CART_TYPES["BANK"] = "banque";
  return CART_TYPES;
}(CART_TYPES || {});
var CUSTOMER_CATEGORY = /*#__PURE__*/function (CUSTOMER_CATEGORY) {
  CUSTOMER_CATEGORY["GP"] = "GP";
  CUSTOMER_CATEGORY["PRO"] = "PRO";
  CUSTOMER_CATEGORY["ENTREPRISE"] = "ENTREPRISE";
  return CUSTOMER_CATEGORY;
}(CUSTOMER_CATEGORY || {});
var CUSTOMER_TYPE = /*#__PURE__*/function (CUSTOMER_TYPE) {
  CUSTOMER_TYPE["CLIENT"] = "CLIENT";
  CUSTOMER_TYPE["PROSPECT"] = "PROSPECT";
  return CUSTOMER_TYPE;
}(CUSTOMER_TYPE || {});
var PRICE_TYPES = /*#__PURE__*/function (PRICE_TYPES) {
  PRICE_TYPES[PRICE_TYPES["Today"] = 0] = "Today";
  PRICE_TYPES[PRICE_TYPES["EvryMonth"] = 1] = "EvryMonth";
  PRICE_TYPES[PRICE_TYPES["Other"] = 2] = "Other";
  PRICE_TYPES[PRICE_TYPES["Reported"] = 3] = "Reported";
  PRICE_TYPES[PRICE_TYPES["EvryMonthIncluded"] = 4] = "EvryMonthIncluded";
  return PRICE_TYPES;
}(PRICE_TYPES || {});
var PAYMENT_MODE = /*#__PURE__*/function (PAYMENT_MODE) {
  PAYMENT_MODE["PRELEVEMENT"] = "PRELEVEMENT";
  PAYMENT_MODE["CB_OU_CHEQUE"] = "CB_OU_CHEQUE";
  return PAYMENT_MODE;
}(PAYMENT_MODE || {});
var SOURCE_PROSPECT = /*#__PURE__*/function (SOURCE_PROSPECT) {
  SOURCE_PROSPECT["BOUYGUES_TELECOM_BUSINESS_DISTRIBUTION"] = "BOUYGUES_TELECOM_BUSINESS_DISTRIBUTION";
  SOURCE_PROSPECT["EURO_INFORMATION"] = "EURO_INFORMATION";
  return SOURCE_PROSPECT;
}(SOURCE_PROSPECT || {});
var SHIPPING_MODES$1 = /*#__PURE__*/function (SHIPPING_MODES) {
  SHIPPING_MODES["CLICK_AND_COLLECT"] = "CLICK_COLLECT";
  SHIPPING_MODES["RELAIS_EXPRESS"] = "POINT_RELAIS_EXPRESS";
  SHIPPING_MODES["RELAIS_COLIS"] = "POINT_RELAIS";
  SHIPPING_MODES["LA_POSTE"] = "LA_POSTE";
  SHIPPING_MODES["CHRONOPOST"] = "CHRONOPOST";
  SHIPPING_MODES["INSTALLER"] = "INSTALLATEUR";
  SHIPPING_MODES["DIRECT"] = "LIVRAISON_DIRECTE";
  SHIPPING_MODES["LIVRAISON_RDV"] = "LIVRAISON_RDV";
  return SHIPPING_MODES;
}(SHIPPING_MODES$1 || {});
var FUNDING_ENUM = /*#__PURE__*/function (FUNDING_ENUM) {
  FUNDING_ENUM["CASH"] = "COMPTANT";
  FUNDING_ENUM["COFIDIS"] = "COFIDIS";
  FUNDING_ENUM["COFIDIS_X3"] = "COFIDIS_X3";
  FUNDING_ENUM["COFIDIS_X12"] = "COFIDIS_X12";
  FUNDING_ENUM["COFIDIS_X24"] = "COFIDIS_X24";
  FUNDING_ENUM["MULTI_PRODUCT"] = "MULTI_PRODUIT";
  FUNDING_ENUM["EDP"] = "EDP";
  FUNDING_ENUM["YOUNITED"] = "YOUNITED";
  FUNDING_ENUM["YOUNITED_X3"] = "YOUNITED_X3";
  FUNDING_ENUM["YOUNITED_X12"] = "YOUNITED_X12";
  FUNDING_ENUM["YOUNITED_X24"] = "YOUNITED_X24";
  FUNDING_ENUM["YOUNITED_X36"] = "YOUNITED_X36";
  FUNDING_ENUM["SWAPPY_X3"] = "REPRISE_GARANTIE_YOUNITED_X3";
  FUNDING_ENUM["SWAPPY_X12"] = "REPRISE_GARANTIE_YOUNITED_X12";
  FUNDING_ENUM["SWAPPY_X24"] = "REPRISE_GARANTIE_YOUNITED_X24";
  FUNDING_ENUM["SWAPPY_X36"] = "REPRISE_GARANTIE_YOUNITED_X36";
  FUNDING_ENUM["SWAPPY"] = "SWAPPY";
  return FUNDING_ENUM;
}(FUNDING_ENUM || {});
var FUNDING_PRODUCT_ENUM = /*#__PURE__*/function (FUNDING_PRODUCT_ENUM) {
  FUNDING_PRODUCT_ENUM["EDP"] = "EDP";
  return FUNDING_PRODUCT_ENUM;
}(FUNDING_PRODUCT_ENUM || {});
var PAYMENT_STATUS_ENUM = /*#__PURE__*/function (PAYMENT_STATUS_ENUM) {
  PAYMENT_STATUS_ENUM["OK"] = "OK";
  PAYMENT_STATUS_ENUM["KO"] = "KO";
  PAYMENT_STATUS_ENUM["REDIRECT"] = "REDIRECTION";
  return PAYMENT_STATUS_ENUM;
}(PAYMENT_STATUS_ENUM || {});
const FUNDING_METHODS_DETAILS = {
  COMPTANT: {
    label: 'Comptant'
  },
  COFIDIS: {
    label: 'Financement Cofidis Pay'
  },
  COFIDIS_X3: {
    label: 'Paiement en 3x sans frais'
  },
  COFIDIS_X12: {
    label: 'Paiement en 12x avec Cofidis Pay'
  },
  COFIDIS_X24: {
    label: 'Paiement en 24x avec Cofidis Pay'
  },
  YOUNITED: {
    label: 'Financement à crédit',
    fullLabel: 'Financement en plusieurs fois avec Younited'
  },
  YOUNITED_X3: {
    label: 'Paiement 3 fois avec Younited'
  },
  YOUNITED_X12: {
    label: 'Paiement 12 fois avec Younited'
  },
  YOUNITED_X24: {
    label: 'Paiement 24 fois avec Younited'
  },
  YOUNITED_X36: {
    label: 'Paiement 36 fois avec Younited'
  },
  SWAPPY: {
    label: 'Financement Swappy',
    fullLabel: 'Financement en plusieurs fois avec Younited - Swappy'
  }
};
var QUOTE_CONTEXTS = /*#__PURE__*/function (QUOTE_CONTEXTS) {
  QUOTE_CONTEXTS["ACQUISITION"] = "ACQUISITION";
  QUOTE_CONTEXTS["ACQUISITIONFIX"] = "ACQUISITIONFIX";
  QUOTE_CONTEXTS["RENEW"] = "RENOUVELLEMENT";
  return QUOTE_CONTEXTS;
}(QUOTE_CONTEXTS || {});
var PRICES_CONTEXTS = /*#__PURE__*/function (PRICES_CONTEXTS) {
  PRICES_CONTEXTS["ACQUISITION"] = "ACQUISITION";
  PRICES_CONTEXTS["RENEW"] = "RENEW";
  return PRICES_CONTEXTS;
}(PRICES_CONTEXTS || {});
var UPDATE_ACTIONS = /*#__PURE__*/function (UPDATE_ACTIONS) {
  UPDATE_ACTIONS["ADD"] = "add";
  UPDATE_ACTIONS["REMOVE"] = "remove";
  return UPDATE_ACTIONS;
}(UPDATE_ACTIONS || {});
var LIGNE_MARCHE = /*#__PURE__*/function (LIGNE_MARCHE) {
  LIGNE_MARCHE["FNB"] = "FNB";
  LIGNE_MARCHE["FAI"] = "FAI";
  return LIGNE_MARCHE;
}(LIGNE_MARCHE || {});
var CONTRACT_STATUS = /*#__PURE__*/function (CONTRACT_STATUS) {
  CONTRACT_STATUS["ACTIVE"] = "ACTIF";
  CONTRACT_STATUS["SUSPENDED"] = "SUSPENDU";
  CONTRACT_STATUS["DEACTIVATED"] = "DESACTIVE";
  return CONTRACT_STATUS;
}(CONTRACT_STATUS || {});
var TYPE_LIGNE = /*#__PURE__*/function (TYPE_LIGNE) {
  TYPE_LIGNE["FIXE"] = "FIXE";
  TYPE_LIGNE["MOBILE"] = "MOBILE";
  return TYPE_LIGNE;
}(TYPE_LIGNE || {});
var LIMITED_RANGE = /*#__PURE__*/function (LIMITED_RANGE) {
  LIMITED_RANGE["SE_MEDIUM"] = "se_medium";
  return LIMITED_RANGE;
}(LIMITED_RANGE || {});
var CommercialSeries = /*#__PURE__*/function (CommercialSeries) {
  CommercialSeries["B_AND_YOU"] = "serie_client_bandyou";
  CommercialSeries["BANQUE"] = "banque";
  CommercialSeries["BTS"] = "bts";
  CommercialSeries["GAMING"] = "gaming";
  CommercialSeries["SERIE_SPECIALE"] = "serie_speciale";
  CommercialSeries["SERIE_LIMITEE"] = "serie_limitee";
  CommercialSeries["SMART_TV"] = "smart_tv";
  CommercialSeries["STANDARD"] = "standard";
  CommercialSeries["TABLETTE"] = "tablette";
  return CommercialSeries;
}(CommercialSeries || {});
var LimitedCommercialSeries = /*#__PURE__*/function (LimitedCommercialSeries) {
  LimitedCommercialSeries["B_AND_YOU"] = "serie_client_bandyou";
  return LimitedCommercialSeries;
}(LimitedCommercialSeries || {});
var RangesNewGeneration = /*#__PURE__*/function (RangesNewGeneration) {
  RangesNewGeneration["VERY_FIT"] = "very_fit";
  RangesNewGeneration["FIT"] = "fit";
  RangesNewGeneration["MUST"] = "must";
  RangesNewGeneration["ULTYM"] = "ultym";
  RangesNewGeneration["HISTORICAL"] = "historique";
  return RangesNewGeneration;
}(RangesNewGeneration || {});
// Interfaces

class CheckoutCartModel extends CartModel {
  cartId;
  type;
  configId;
  userId;
  lastProductParamsSent;
  coupon;
  isComingFromProWall = false;
  fundingMethod;
  availableFundingMethods = [];
  isBanking() {
    return this.type === CART_TYPES.BANK;
  }
  isMixed() {
    return this.quotes?.filter(quote => quote.products?.some(p => p.isPrincipal)).length > 1;
  }
  isTelOnly() {
    return this.quotes[0].products.filter(p => !ProductFactory.Is(p, Insurance) && !ProductFactory.Is(p, Edp)).every(product => ProductFactory.Is(product, Phone));
  }
  isFaiOnly() {
    const quote = this.quotes[0];
    return !this.isMixed() && quote.isAcquisitionFix() && ProductFactory.Is(quote.getPrincipalProduct(Fai), Fai, true);
  }
  isAccessoryOnly() {
    return this.quotes[0].products.every(product => ProductFactory.Is(product, Accessory) || ProductFactory.Is(product, Delivery));
  }
  /**
   * Checks if the cart is a swappy cart.
   * @returns true if the cart is a swappy cart, false otherwise.
   */
  isSwappy() {
    return this.quotes[0].products.some(product => ProductFactory.Is(product, Plan) && product.data.sub_type_id === 'swappy');
  }
}
class DeliveryInfo {
  adresse;
  methodInfo;
  pickup;
  appointment;
  // controleAutoGCP: boolean;
  prix;
  libelle;
  gencode;
  typePrix;
  constructor(data) {
    Object.assign(this, data);
  }
  getApiData() {
    const apiData = {
      gencode: this.gencode
    };
    if (this.pickup) {
      if (this.pickup.deliveryType === SHIPPING_MODES$1.CLICK_AND_COLLECT) {
        apiData.entiteReseauDistribution = {
          codeEnseigne: this.pickup.brandId,
          nom: this.pickup.name,
          codePointVente: this.pickup.rvc
        };
      } else {
        apiData.pointRelais = {
          codeIdentification: this.pickup.id,
          libelle: this.pickup.name
        };
        if (this.pickup.rvc) {
          apiData.pointRelais.codeSecteurLivraison = this.pickup.rvc;
        }
      }
    }
    if (this.appointment) {
      apiData.creneauChoisi = this.appointment;
    }
    return apiData;
  }
}
class FundingCart {
  idCart;
  fundingMethods;
  pathway;
  constructor(data) {
    Object.assign(this, data);
  }
}
class FundingMethod {
  label;
  fullLabel;
  paymentModes;
  commercialProposal;
  type;
  position;
  constructor(data) {
    Object.assign(this, data);
  }
}
class QuoteContextRenewalModel extends QuoteContextRenewalModel$1 {
  codeTac;
  options;
  phone;
  currentPlan;
  constructor(params) {
    super(params);
  }
  getData() {
    return {
      id: this.id,
      contractId: this.contractId,
      options: this.options,
      phone: this.phone,
      codeTac: this.codeTac,
      clientType: this.clientType,
      nbTerms: this.nbTerms,
      currentPlan: this.currentPlan
    };
  }
}
class ShippingMethodModel {
  gencode;
  label;
  estimatedDeveliveryDate;
  estimatedLatestDeliveryDate;
  limitHour;
  price;
  cuttOff;
  quoteType;
  priceType;
  constructor(data) {
    Object.assign(this, data);
    if (this.limitHour) {
      const cutOff = new Date();
      cutOff.setHours(+this.limitHour.slice(0, 2));
      cutOff.setMinutes(+this.limitHour.slice(3, 5));
      cutOff.setSeconds(+this.limitHour.slice(6, 8));
      this.cuttOff = cutOff;
    }
  }
  isTomorrowDeliverable() {
    return !this.limitHour && differenceInDays(Date.now(), new Date(this.estimatedDeveliveryDate)) <= 1;
  }
  getTimeToLimit() {
    const currentDate = new Date();
    if (!this.isTomorrowDeliverable() || this.cuttOff.valueOf() <= currentDate.valueOf()) {
      return null;
    }
    // Manage UTC date - KO with date-fns
    const isoDate = new Date(this.cuttOff.getTime() - currentDate.getTime()).toISOString();
    const hours = isoDate.substr(11, 2);
    const minutes = isoDate.substr(14, 2);
    const seconds = isoDate.substr(17, 2);
    return `${hours}h ${minutes}m ${seconds}s pour être livré dès demain`;
  }
}
class User {
  address = null;
  contracts;
  contactDetails;
  defaultContract = null;
  renewContractId;
  id = null;
  session = null;
  idIdentite = null;
  idPersonneIdentifiee = null;
  type = null;
  siren = null;
  representantLegal = null;
  codeApeNaf = null;
  dateCreation = null;
  effectif = null;
  formeJuridique = null;
  raisonSociale = null;
  _links = null;
  _actions = null;
  noTvaIntracommunautaire = null;
  isMigratingPlan = false;
  invoicingInfo = null;
  civilite = null;
  codeDepartementNaissance = null;
  dateNaissance = null;
  departementNaissance = null;
  vip = false;
  nom = null;
  prenom = null;
  typeContrats = null;
  paymentMethod = null;
  _mainPhone;
  _mainEmail;
  setData(data) {
    Object.assign(this, data);
  }
  updateData(data) {
    const CONTRACTS_KEYS = {
      email: {
        key: 'emails',
        dataKey: '_mainEmail'
      },
      numeroTel: {
        key: 'telephones',
        dataKey: '_mainPhone'
      }
    };
    Object.keys(data).forEach(key => {
      if (key in CONTRACTS_KEYS && this.idIdentite) {
        const newData = data[key];
        const contactDataKey = CONTRACTS_KEYS[key].key;
        this.update(CONTRACTS_KEYS[key].dataKey, {
          [key]: newData
        });
        if (this.contactDetails[contactDataKey].length) {
          this.contactDetails[contactDataKey][0][key] = newData;
        }
      } else {
        if (key in this) {
          this[key] = data[key];
        }
      }
    });
  }
  isPro() {
    return !!this.siren;
  }
  isEditable() {
    return !!this._actions?.modifierprospect;
  }
  hasContract() {
    return this.contracts?.length > 0;
  }
  get mainEmail() {
    const emails = this.contactDetails?.emails || [];
    this._mainEmail = emails.find(email => !!email.emailPrincipal);
    return this._mainEmail;
  }
  get mainPhone() {
    const phones = this.contactDetails?.telephones || [];
    this._mainPhone = phones.find(phone => !!phone.telephonePrincipal);
    return this._mainPhone;
  }
  update(key, data) {
    this[key] = {
      ...this[key],
      ...data
    };
  }
  getCivility() {
    return this.representantLegal?.civilite || this.civilite;
  }
  setAddressFromSirenData(sirenDataAddress) {
    if (sirenDataAddress) {
      this.address = {
        codePostal: sirenDataAddress.cp,
        numeroRue: sirenDataAddress.num,
        ville: sirenDataAddress.ville,
        rue: sirenDataAddress.voie
      };
    }
  }
  getSirenAddress(address) {
    if (address) {
      return {
        cp: address.codePostal,
        num: address.numeroRue,
        ville: address.ville,
        voie: address.rue
      };
    }
    return null;
  }
  setSirenData(sirenData) {
    if (sirenData) {
      this.siren = sirenData.noSiren || sirenData.siren;
      this.representantLegal = sirenData.representantLegal;
      this.codeApeNaf = sirenData.codeApeNaf;
      this.dateCreation = sirenData.dateCreation;
      this.effectif = sirenData.codeEffectif;
      this.formeJuridique = sirenData.formeJuridique;
      this.raisonSociale = sirenData.raisonSociale;
      this.setAddressFromSirenData(sirenData.adresseDeclaree);
      if (this.representantLegal?.civilite === 'MLLE') {
        this.representantLegal.civilite = 'MME';
      }
    }
  }
  getSirenData() {
    return {
      siren: this.siren,
      representantLegal: this.representantLegal,
      codeApeNaf: this.codeApeNaf,
      dateCreation: this.dateCreation,
      codeEffectif: this.effectif,
      formeJuridique: this.formeJuridique,
      raisonSociale: this.raisonSociale
    };
  }
  deleteSirenData() {
    delete this.siren;
    delete this.representantLegal;
    delete this.codeApeNaf;
    delete this.dateCreation;
    delete this.effectif;
    delete this.formeJuridique;
    delete this.raisonSociale;
    delete this.address;
  }
  isOnlyMobile() {
    return this.contracts.filter(contract => contract.statut === CONTRACT_STATUS.ACTIVE).every(contract => contract.typeLigne === TYPE_LIGNE.MOBILE && !contract.abonnement?.offreTokyo && !contract.abonnement?.offreDataMobile);
  }
}
class CustomHttpParamEncoder {
  encodeKey(key) {
    return encodeURIComponent(key);
  }
  encodeValue(value) {
    return encodeURIComponent(value);
  }
  decodeKey(key) {
    return decodeURIComponent(key);
  }
  decodeValue(value) {
    return decodeURIComponent(value);
  }
}
class IPrismeLog {
  project;
  st;
  login;
  idPersonne;
  idContrat;
  nom;
  severite;
  message;
  enErreur;
  erreurType;
  erreurCode;
  erreurDescription;
  erreurOrigine;
  role;
  trackerId;
}
class IPrismeMap {
  RESSOURCE;
  MAGENTO;
}
// @dynamic
let BtlPrismeService = /*#__PURE__*/(() => {
  class BtlPrismeService {
    oauth2;
    config;
    cookieStorage;
    http;
    document;
    COOKIE_KEY = 'SESSION_PRISME';
    logStructure;
    sourceNameUrlMap;
    constructor(oauth2, config, cookieStorage, http, document) {
      this.oauth2 = oauth2;
      this.config = config;
      this.cookieStorage = cookieStorage;
      this.http = http;
      this.document = document;
      this._initialize();
    }
    /**
     * Bare settings for Tag service
     */
    log(url, type, erreurCode, erreurDescription) {
      if (!erreurDescription) {
        erreurDescription = '';
      }
      const source = this._getSourceName(url);
      const data = {
        nom: `${source} - ${url.split('/').splice(3, 9999).join(' ').toUpperCase()}`,
        severite: type,
        message: url,
        erreurCode,
        erreurDescription: erreurDescription.replace('::', ':'),
        erreurOrigine: source,
        trackerId: this.getSession()
      };
      let returnValue = Object.assign({}, this.logStructure, data);
      if (this.oauth2.isConnected && this.oauth2.jwtPayload) {
        const loggedUserData = {
          login: this.oauth2.jwtPayload.login,
          role: this.oauth2.jwtPayload.user_type,
          idPersonne: this.oauth2.jwtPayload.id_personne,
          userType: this.oauth2.jwtPayload.user_type
        };
        returnValue = Object.assign(returnValue, loggedUserData);
      }
      return this._send(returnValue);
    }
    getSession() {
      return this.cookieStorage.get(this.COOKIE_KEY);
    }
    _send(data) {
      if (!this.config.getData().prisme.status || !this.config.getData().prisme.js_error) {
        return;
      }
      let stringValue = '';
      for (const key in data) {
        if (data[key]) {
          if (stringValue !== '') {
            stringValue += '::';
          }
          stringValue += `${key}=${data[key]}`;
        }
      }
      const queryString = new HttpParams().set('info', btoa(stringValue));
      const httpOptions = {
        params: queryString
      };
      return this.http.get(this.config.getData().prisme.url, httpOptions).pipe(catchError(error => {
        console.error(error);
        return of(null);
      }));
    }
    _getSourceName(url) {
      if (!url) {
        return 'MAGENTO';
      }
      for (const key in this.sourceNameUrlMap) {
        if (url.includes(this.sourceNameUrlMap[key])) {
          return key;
        }
      }
      return 'AUTRE';
    }
    _initialize() {
      const windowDom = this.document.defaultView.window;
      windowDom.prisme = this;
      this.logStructure = {
        project: 'MAGENTO_FO',
        st: 'MAGENTO_FO',
        login: '',
        idPersonne: null,
        idContrat: null,
        nom: '',
        severite: '',
        message: '',
        enErreur: true,
        erreurType: 'Technique',
        erreurCode: null,
        erreurDescription: '',
        erreurOrigine: '',
        role: '',
        trackerId: ''
      };
      this.sourceNameUrlMap = {
        RESSOURCE: this.config.baseConfig.oauth.resourceUrl,
        MAGENTO: windowDom.location.origin
      };
      if (!this.getSession()) {
        const expire = new Date();
        expire.setDate(expire.getDate() + 1);
        const guid = v4();
        this.cookieStorage.setItem(this.COOKIE_KEY, guid, expire);
      }
    }
    static ɵfac = function BtlPrismeService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BtlPrismeService)(i0.ɵɵinject(Oauth2Service), i0.ɵɵinject(ConfigurationService), i0.ɵɵinject(CookieStorageService), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(DOCUMENT));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: BtlPrismeService,
      factory: BtlPrismeService.ɵfac,
      providedIn: 'root'
    });
  }
  return BtlPrismeService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Oauth2ResourcesService = /*#__PURE__*/(() => {
  class Oauth2ResourcesService {
    oauth2;
    http;
    configService;
    prismeService;
    static HTTP_UNAUTHORIZED = 401;
    inService = false;
    store;
    headers = {};
    localService = false;
    params;
    resourceUrl = '';
    constructor(oauth2, http, configService, prismeService) {
      this.oauth2 = oauth2;
      this.http = http;
      this.configService = configService;
      this.prismeService = prismeService;
      this.params = new HttpParams({
        encoder: new CustomHttpParamEncoder()
      });
    }
    addCache() {
      return this.addHeaders({
        'Cache-Control': 'cache-js'
      });
    }
    addHeaders(headers) {
      const resource = this.getInstance();
      resource.headers = Object.assign(resource.headers, headers);
      return resource;
    }
    adresseLivraison() {
      return this.getResource('/adresses-livraison');
    }
    adresseFacturation() {
      return this.getResource('/adresse-facturation');
    }
    categories(id) {
      return this.getResource(`/categories${id ? '/' + id : ''}`);
    }
    commande(id) {
      let resourceUrl = '/commande';
      if (id) {
        resourceUrl += '/' + id.toString();
      }
      return this.getResource(resourceUrl);
    }
    compatibiliteSim() {
      return this.getResource('/compatibilite-sim');
    }
    config() {
      return this.getResource('/config');
    }
    configuration() {
      return this.getResource('/configuration');
    }
    contracts(contractId) {
      const resourceUrl = '/contrats/' + contractId;
      return this.getResource(resourceUrl);
    }
    validationEmail() {
      const resource = this.getResource('/adresses/validation-email');
      resource._addSpecialHeader(true, false);
      return resource;
    }
    controleSiren(siren) {
      const resourceUrl = '/controleSiren/' + siren;
      return this.getResource(resourceUrl);
    }
    invoicingInfo(siren) {
      const resourceUrl = '/entites-juridiques-routage-factures?numeroSiren=' + siren;
      return this.getResource(resourceUrl);
    }
    creneauxLivraison() {
      return this.getResource('/creneaux-livraison');
    }
    recherche() {
      return this.getResource('/recherche');
    }
    delete() {
      return this.getRequest('DELETE');
    }
    eligibilite(idPanier) {
      const resourceUrl = `/eligibilite${idPanier ? '/' + idPanier : ''}`;
      return this.getResource(resourceUrl);
    }
    eligibilitesRenouvellement() {
      return this.getResource('/eligibilites-renouvellement');
    }
    eligibilityEdpTerminalNu() {
      return this.getResource('/etalement-de-paiement-terminal-nu');
    }
    etalementDePaiementRenouvellement() {
      return this.getResource('/etalement-de-paiement-renouvellement');
    }
    gcp() {
      return this.getResource('/gcp');
    }
    get() {
      return this.getRequest('GET');
    }
    getClient() {
      return this.http;
    }
    getUrl() {
      return this._getRequestUrl() + this.resourceUrl;
    }
    iban() {
      return this.getResource('/iban');
    }
    lignes() {
      return this.getResource('/lignes');
    }
    mobileUsage() {
      return this.getResource('/mobile-usage');
    }
    modesLivraison() {
      return this.getResource('/modes-livraison');
    }
    modesFinancement() {
      return this.getResource('/modes-financement');
    }
    modesFinancementVirtuel() {
      return this.getResource('/referentiel/modes-financement');
    }
    courant() {
      return this.getResource('/courant');
    }
    offres(id) {
      const resourceUrl = `/offres${id ? '/' + id.toString() : ''}`;
      return this.getResource(resourceUrl);
    }
    offresAdditionnellesSouscriptibles() {
      return this.getResource('/offres-additionnelles-souscriptibles');
    }
    options() {
      return this.getResource('/options');
    }
    optionsSouscriptibles() {
      const resource = this.getResource('/options-souscriptibles');
      resource.addHeaders({
        'x-version': '2'
      });
      return resource;
    }
    panier(id) {
      const resourceUrl = `/paniers${id ? '/' + id.toString() : ''}`;
      return this.getResource(resourceUrl);
    }
    parcours(id) {
      const resourceUrl = `/parcours${id ? '/' + id.toString() : ''}`;
      return this.getResource(resourceUrl);
    }
    post(body) {
      return this.getRequest('POST', body);
    }
    tarificationSim() {
      return this.getResource('/tarification-sims');
    }
    produits(id) {
      const resourceUrl = `/produits${id ? '/' + id : ''}`;
      return this.getResource(resourceUrl);
    }
    promotions(id) {
      const resourceUrl = `/promotions${id ? '/' + id : ''}`;
      return this.getResource(resourceUrl);
    }
    promotionsDisponibles() {
      return this.getResource('/promotions-disponibles');
    }
    eligibilitePromotionnelle() {
      return this.getResource('/eligibilite-promotionnelle');
    }
    prospect() {
      return this.getResource('/prospect');
    }
    prospectWEB() {
      return this.getResource('/prospectWEB');
    }
    put(body) {
      return this.getRequest('PUT', body);
    }
    referentiel() {
      return this.getResource('/referentiel');
    }
    ressources() {
      return this.getResource('/ressources');
    }
    scoring() {
      return this.getResource('/scoring');
    }
    session() {
      return this.getResource('/session');
    }
    setLocalService(flag = true) {
      const resource = this.getInstance();
      resource.localService = flag;
      return resource;
    }
    setParams(params) {
      const resource = this.getInstance();
      Object.keys(params).forEach(key => {
        resource.params = resource.params.set(key, '' + params[key]);
      });
      return resource;
    }
    setUrl(resourceUrl) {
      const resource = this.getInstance();
      resource.resourceUrl += resourceUrl;
      return resource;
    }
    techno(techno) {
      return this.getResource('/' + techno);
    }
    token() {
      return this.getResource('/token');
    }
    useSalesApi() {
      const resource = this.getInstance();
      resource.headers['x-version'] = this.configService.baseConfig.oauth.salesApiVersion || '4';
      return resource;
    }
    ventes() {
      this.setLocalService();
      return this.getResource('/ventes');
    }
    simsContextualises() {
      return this.getResource(`/catalogue/sims-contextualises`);
    }
    _getRequestOptions() {
      this.setTrackerId();
      if (this.configService.baseConfig.environment !== 'PROD' && this.configService.baseConfig.environment !== 'LOCAL') {
        this.headers['X-banc'] = this.configService.baseConfig.oauth.xBanc;
      }
      if (this.oauth2.access_token) {
        this.headers.Authorization = `Bearer ${this.oauth2.access_token}`;
      }
      return {
        headers: new HttpHeaders(this.headers),
        params: this.params
      };
    }
    _getRequestUrl() {
      return this.configService.baseConfig.oauth.resourceUrl;
    }
    getInstance() {
      if (this.inService) {
        return this;
      } else {
        const instance = new this.constructor(this.oauth2, this.getClient(), this.configService, this.prismeService);
        instance.inService = true;
        return instance;
      }
    }
    getRequest(httpMethod, body) {
      const http = this.http;
      let obs;
      switch (httpMethod) {
        case 'POST':
          obs = http.post(this.getUrl(), body, this._getRequestOptions());
          break;
        case 'PUT':
          obs = http.put(this.getUrl(), body, this._getRequestOptions());
          break;
        case 'GET':
          obs = http.get(this.getUrl(), this._getRequestOptions());
          break;
        case 'DELETE':
          obs = http.delete(this.getUrl(), this._getRequestOptions());
          break;
        default:
          throw Error('Unknow HTTP method');
      }
      return obs.pipe(catchError(res => {
        if (res.status === Oauth2ResourcesService.HTTP_UNAUTHORIZED) {
          return this.oauth2.login().pipe(mergeMap(() => obs));
        }
        throw res;
      }), publishLast(), refCount());
    }
    getResource(resourceUrl) {
      const resource = this.getInstance();
      resource.resourceUrl += resourceUrl;
      resource._addSpecialHeader();
      return resource;
    }
    setTrackerId() {
      this.headers.TrackerId = this.prismeService.getSession();
      return this;
    }
    _addSpecialHeader(xsource = true, xmessage = true) {
      const resource = this.getInstance();
      const headers = {};
      if (xsource) {
        headers['X-Source'] = this.configService.baseConfig.oauth.xSource || 'MAGENTO';
        headers.Source = this.configService.baseConfig.oauth.xSource || 'MAGENTO'; // cas specifique
      }
      if (xmessage) {
        headers['X-Message-Id'] = this._getHash();
      }
      resource.addHeaders(headers);
      return resource;
    }
    _getHash() {
      const ts = new Date().getTime().toString().split('');
      const hash = [];
      for (const val of ts) {
        hash.push(Math.floor(1 + Math.random() * 0x10000).toString(16).substring(1) + val);
      }
      return `${hash[0]}${hash[1]}-${hash[2]}-${hash[3]}-${hash[4]}-${hash[5]}${hash[6]}${hash[7]}`;
    }
    static ɵfac = function Oauth2ResourcesService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || Oauth2ResourcesService)(i0.ɵɵinject(Oauth2Service), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(ConfigurationService), i0.ɵɵinject(BtlPrismeService));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: Oauth2ResourcesService,
      factory: Oauth2ResourcesService.ɵfac,
      providedIn: 'root'
    });
  }
  return Oauth2ResourcesService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CheckoutOauth2ResourcesService = /*#__PURE__*/(() => {
  class CheckoutOauth2ResourcesService extends Oauth2ResourcesService {
    oauth2;
    http;
    configService;
    prismeService;
    errorSubject = new Subject();
    lockedSubject$ = new Subject();
    _displayErrors = false;
    constructor(oauth2, http, configService, prismeService) {
      super(oauth2, http, configService, prismeService);
      this.oauth2 = oauth2;
      this.http = http;
      this.configService = configService;
      this.prismeService = prismeService;
    }
    displayErrors() {
      this._displayErrors = true;
      return this.getInstance();
    }
    isError(httpError, httpErrorType) {
      return httpError.status.toString().startsWith(httpErrorType);
    }
    getInstance() {
      const instance = super.getInstance();
      instance.errorSubject = this.errorSubject;
      instance.lockedSubject$ = this.lockedSubject$;
      return instance;
    }
    getRequest(httpMethod, body) {
      const obs = super.getRequest(httpMethod, body);
      return obs.pipe(takeUntil(this.lockedSubject$), catchError(res => {
        if (this._displayErrors && res instanceof HttpErrorResponse) {
          this.errorSubject.next(res);
        }
        throw res;
      }));
    }
    static ɵfac = function CheckoutOauth2ResourcesService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CheckoutOauth2ResourcesService)(i0.ɵɵinject(Oauth2Service), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(ConfigurationService), i0.ɵɵinject(BtlPrismeService));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CheckoutOauth2ResourcesService,
      factory: CheckoutOauth2ResourcesService.ɵfac,
      providedIn: 'root'
    });
  }
  return CheckoutOauth2ResourcesService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AppointmentRepository = /*#__PURE__*/(() => {
  class AppointmentRepository {
    oauth2Resource;
    constructor(oauth2Resource) {
      this.oauth2Resource = oauth2Resource;
    }
    getAppointments(address) {
      return this.oauth2Resource.useSalesApi().creneauxLivraison().recherche().post({
        adresseLivraison: {
          codePostal: address.codePostal,
          complementAdresse: address.complementAdresse,
          numero: address.numeroRue,
          rue: address.rue,
          ville: address.ville
        },
        reseauLivraison: ['CHRONOPOST']
      });
    }
    static ɵfac = function AppointmentRepository_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AppointmentRepository)(i0.ɵɵinject(CheckoutOauth2ResourcesService));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AppointmentRepository,
      factory: AppointmentRepository.ɵfac,
      providedIn: 'root'
    });
  }
  return AppointmentRepository;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class StorageConf {}
let StorageService = /*#__PURE__*/(() => {
  class StorageService {
    localKeysConf = {
      configurations: []
    };
    sessionKeysConf = {};
    prefix = 'bytel';
    type;
    configService = inject(ConfigurationService);
    clear() {
      this.clearTag();
    }
    clearTag(tag = null) {
      this._cleanStorage(this.sessionKeysConf, tag);
      this._cleanStorage(this.localKeysConf, tag);
    }
    get(key, prefix = true) {
      let item = null;
      const storageItem = this._getData(key, prefix);
      if (storageItem !== null) {
        try {
          item = storageItem.hasOwnProperty('data') ? storageItem.data : storageItem;
          const now = new Date().getTime();
          if (storageItem.expiresTimestamp && storageItem.expiresTimestamp < now) {
            item = null;
            this.remove(key, prefix);
          }
        } catch (e) {
          console.error(e);
        }
      }
      return item;
    }
    getExpires(key, prefix = true) {
      const storageItem = this._getData(key, prefix);
      if (storageItem !== null) {
        return storageItem?.expiresTimestamp;
      }
    }
    remove(key, prefix = true) {
      const storageKey = prefix ? `${this.prefix}_${key}` : key;
      this._getStorageInstance(key).removeItem(storageKey);
    }
    /**
     *
     * @param key Key value
     * @param value
     * @param prefix if true add checkout_ before key
     * @param expires expirationTimestamp - Set by default from configuration
     */
    set(key, value, prefix = true, expires = this._getDefaultExpirationValue()) {
      // TODO check if valid storage key
      const storageKey = prefix ? `${this.prefix}_${key}` : key;
      const data = JSON.stringify({
        data: value,
        expiresTimestamp: expires
      });
      this._getStorageInstance(key).setItem(storageKey, data);
    }
    addLocalKey(data) {
      this.localKeysConf = {
        ...this.localKeysConf,
        ...data
      };
      return this.localKeysConf;
    }
    addSessionKey(data) {
      this.sessionKeysConf = {
        ...this.sessionKeysConf,
        ...data
      };
      return this.sessionKeysConf;
    }
    _getStorageInstance(key) {
      let storage;
      if (Object.keys(this.sessionKeysConf).includes(key)) {
        storage = sessionStorage;
      } else {
        storage = localStorage;
      }
      return storage;
    }
    _cleanStorage(storageConf, tag = null) {
      Object.keys(storageConf).forEach(key => {
        if (!tag || storageConf[key].includes(tag)) {
          this.remove(key);
          this.remove(key, false);
        }
      });
    }
    _getData(key, prefix = true) {
      const storageKey = prefix ? `${this.prefix}_${key}` : key;
      const data = this._getStorageInstance(key).getItem(storageKey);
      if (data !== null) {
        try {
          return JSON.parse(data);
        } catch (e) {
          console.error(e);
        }
      }
      return null;
    }
    _getDefaultExpirationValue() {
      const expirationConfigValue = this.configService.getConfig().global.expirationCartValue;
      if (expirationConfigValue > 0) {
        const date = new Date();
        date.setHours(date.getHours() + expirationConfigValue);
        return date.getTime();
      }
      return null;
    }
    static ɵfac = function StorageService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StorageService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: StorageService,
      factory: StorageService.ɵfac,
      providedIn: 'any'
    });
  }
  return StorageService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var STORAGE_TAGS = /*#__PURE__*/function (STORAGE_TAGS) {
  STORAGE_TAGS["ORDER"] = "ORDER";
  STORAGE_TAGS["CUSTOMER"] = "CUSTOMER";
  STORAGE_TAGS["ELIGIBILITY"] = "ELIGIBILITY";
  return STORAGE_TAGS;
}(STORAGE_TAGS || {});
let CheckoutStorageService = /*#__PURE__*/(() => {
  class CheckoutStorageService extends StorageService {
    prefix = 'checkout';
    constructor() {
      super();
      this.localKeysConf = {
        cart: [STORAGE_TAGS.ORDER],
        galliumPrices: [STORAGE_TAGS.ORDER, STORAGE_TAGS.CUSTOMER],
        click_collect: [STORAGE_TAGS.ORDER],
        eligibility: [STORAGE_TAGS.ELIGIBILITY],
        fai_elige_tokyo: [STORAGE_TAGS.ELIGIBILITY],
        eligibilityUserAddress: [STORAGE_TAGS.ELIGIBILITY],
        plan_cart_scheme: [STORAGE_TAGS.ORDER],
        phone_scheme: [STORAGE_TAGS.ORDER],
        fai: [STORAGE_TAGS.ELIGIBILITY],
        provider_results: [STORAGE_TAGS.ELIGIBILITY],
        current_step: [STORAGE_TAGS.ORDER]
      };
      this.sessionKeysConf = {
        mrz: [STORAGE_TAGS.ORDER, STORAGE_TAGS.CUSTOMER],
        promoConfigurator: [STORAGE_TAGS.ORDER],
        steps: [STORAGE_TAGS.ORDER],
        mobile_recovery_current_product: [STORAGE_TAGS.ORDER],
        mobileRecoveryCurrentStep: [STORAGE_TAGS.ORDER],
        scoring: [STORAGE_TAGS.CUSTOMER],
        deviceFingerPrint: [STORAGE_TAGS.CUSTOMER],
        deviceFingerPrintKeys: [STORAGE_TAGS.CUSTOMER],
        UUID: [STORAGE_TAGS.CUSTOMER],
        ftth3Clics: [STORAGE_TAGS.ORDER],
        idsPorta: [STORAGE_TAGS.ORDER],
        customer: [STORAGE_TAGS.CUSTOMER],
        funding_key: [STORAGE_TAGS.ORDER],
        galliumData: [STORAGE_TAGS.CUSTOMER]
      };
    }
    saveConfigurations(configurations) {
      /* Configuration is generated every hour */
      const hourMilliseconds = 3600 * 1000;
      const expirationDate = new Date().getTime() + hourMilliseconds;
      this.set('configurations', configurations, true, expirationDate);
    }
    static ɵfac = function CheckoutStorageService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CheckoutStorageService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CheckoutStorageService,
      factory: CheckoutStorageService.ɵfac,
      providedIn: 'root'
    });
  }
  return CheckoutStorageService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var USER_TITLES = /*#__PURE__*/function (USER_TITLES) {
  USER_TITLES["mister"] = "M.";
  USER_TITLES["missis"] = "MME";
  return USER_TITLES;
}(USER_TITLES || {});
const refCliFormatToFrontFormat = refCliDate => {
  if (!refCliDate) {
    return null;
  }
  const [year, month, day] = refCliDate.split('-');
  return `${day}/${month}/${year}`;
};
const frontFormatToRefCliFormat = frontFormat => {
  const [day, month, year] = frontFormat.split('/');
  return `${year}-${month}-${day}`;
};
const frontFormatToApiVente = birthDate => {
  if (!birthDate) {
    return null;
  }
  const [day, month, year] = birthDate.split('/');
  return `${year}${month}${day}`;
};
const dateSorter = (contract1, contract2) => {
  const date1 = contract1?.abonnement?.dateActivation;
  const date2 = contract2?.abonnement?.dateActivation;
  return new Date(date1) < new Date(date2) ? -1 : 1;
};
let CatalogRepository = /*#__PURE__*/(() => {
  class CatalogRepository {
    oauth2Resource;
    constructor(oauth2Resource) {
      this.oauth2Resource = oauth2Resource;
    }
    /**
     *
     * @param PlanCatalogParams planParams
     * @return Observable<any>
     *
     */
    getProductCategories(categories, withDetailsParam = false, showProductsParam = true) {
      return this.oauth2Resource.useSalesApi().ventes().addCache().categories().setParams({
        withDetails: withDetailsParam,
        voirProduits: showProductsParam,
        codes: categories
      }).get().pipe(map(result => showProductsParam ? Object.values(result.categories) : Object.values(result.categories)));
    }
    /**
     *
     * @return Observable of JsonProduct
     *
     */
    getProductByAttribute(value, attribute) {
      const params = attribute ? {
        attribute
      } : {};
      return this.oauth2Resource.useSalesApi().ventes().produits(value).setParams(params).addCache().get();
    }
    getProductByGencode(gencode) {
      return this.oauth2Resource.ventes().produits().setParams({
        listGencode: gencode
      }).addCache().setLocalService().useSalesApi().get().pipe(map(data => data.produits[Object.keys(data.produits)[0]]));
    }
    getProductsByGencodes(gencodes) {
      const listGencode = gencodes.join(',');
      return this.oauth2Resource.ventes().produits().setParams({
        listGencode
      }).addCache().setLocalService().useSalesApi().get().pipe(map(data => data.produits));
    }
    static ɵfac = function CatalogRepository_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CatalogRepository)(i0.ɵɵinject(Oauth2ResourcesService));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CatalogRepository,
      factory: CatalogRepository.ɵfac,
      providedIn: 'root'
    });
  }
  return CatalogRepository;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var LINKED_API_PRODUCT_TYPE = /*#__PURE__*/function (LINKED_API_PRODUCT_TYPE) {
  LINKED_API_PRODUCT_TYPE["CROSSSELL"] = "crossSellsProducts";
  LINKED_API_PRODUCT_TYPE["UPSELL"] = "upSellsProducts";
  LINKED_API_PRODUCT_TYPE["RELATED"] = "relatedProduct";
  return LINKED_API_PRODUCT_TYPE;
}(LINKED_API_PRODUCT_TYPE || {});
var LINKED_PRODUCT_TYPE = /*#__PURE__*/function (LINKED_PRODUCT_TYPE) {
  LINKED_PRODUCT_TYPE["CROSSSELL"] = "crossSells";
  LINKED_PRODUCT_TYPE["UPSELL"] = "upSells";
  LINKED_PRODUCT_TYPE["RELATED"] = "related";
  return LINKED_PRODUCT_TYPE;
}(LINKED_PRODUCT_TYPE || {});
let ProductRepository = /*#__PURE__*/(() => {
  class ProductRepository {
    catalogRepository;
    constructor(catalogRepository) {
      this.catalogRepository = catalogRepository;
    }
    getProductByGencode(gencode) {
      return this.catalogRepository.getProductByGencode(gencode).pipe(map(product => ProductFactory.GetInstance(product)));
    }
    getProductsByAttributes(values, attribute = null) {
      const productsObs = [];
      values.forEach(value => {
        productsObs.push(this._getProductByAttribute(value, attribute));
      });
      return forkJoin(productsObs);
    }
    getProductsByGencodes(gencodes) {
      if (gencodes.length > 0) {
        return this.catalogRepository.getProductsByGencodes(gencodes).pipe(map(products => Object.values(products).map(product => ProductFactory.GetInstance(product))));
      }
      return throwError(() => new Error('Aucun gencode en paramètre'));
    }
    getLinkedProductAttributes(gencode, type) {
      return this.catalogRepository.getProductByAttribute(gencode).pipe(map(product => {
        if (product[type]) {
          return product[type].map(data => ({
            gencode: data.gencode,
            position: data.position,
            hasDescription: data.hasDescription,
            firstPage: data.first_page,
            essential: data.essential
          }));
        } else {
          return [];
        }
      }), catchError(() => of([])));
    }
    _getProductByAttribute(value, attribute = null) {
      return this.catalogRepository.getProductByAttribute(value, attribute).pipe(map(product => ProductFactory.GetInstance(product)));
    }
    static ɵfac = function ProductRepository_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductRepository)(i0.ɵɵinject(CatalogRepository));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ProductRepository,
      factory: ProductRepository.ɵfac,
      providedIn: 'root'
    });
  }
  return ProductRepository;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// @dynamic
let ProductService = /*#__PURE__*/(() => {
  class ProductService {
    productRepository;
    constructor(productRepository) {
      this.productRepository = productRepository;
    }
    getLinkedProductsByType(product, linkedAttribute, linkedType) {
      if (!product[linkedAttribute] || !product[linkedAttribute].length) {
        return of([]);
      }
      return this.productRepository.getProductsByGencodes(product[linkedAttribute]).pipe(map(products => products.filter(p => ProductFactory.Is(p, linkedType)).map(p => p)));
    }
    getProductByGencode(gencode) {
      return this.productRepository.getProductByGencode(gencode);
    }
    getProductsByGencodes(gencodes) {
      return this.productRepository.getProductsByGencodes(gencodes);
    }
    static ɵfac = function ProductService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductService)(i0.ɵɵinject(ProductRepository));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ProductService,
      factory: ProductService.ɵfac,
      providedIn: 'root'
    });
  }
  return ProductService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var CONTRACT_TYPES = /*#__PURE__*/function (CONTRACT_TYPES) {
  CONTRACT_TYPES["NONE"] = "NONE";
  CONTRACT_TYPES["FNB"] = "FNB";
  CONTRACT_TYPES["FAI"] = "FAI";
  CONTRACT_TYPES["FAI_FNB"] = "FAI_FNB";
  CONTRACT_TYPES["FAI_PREMIUM"] = "FAI_PREMIUM";
  CONTRACT_TYPES["FAI_PREMIUM_FNB"] = "FAI_PREMIUM_FNB";
  return CONTRACT_TYPES;
}(CONTRACT_TYPES || {});
// @dynamic
class UserService {
  static CDC_TYPES = ['CDC', 'SUPPORT'];
  static ERROR_TYPES = {
    CONFLICT: 'USER_CONFLICT',
    UNAUTHORIZED: 'UNAUTHORIZED_CUSTOMER',
    LOGIN: 'LOGIN_ERROR'
  };
  static SIGNUP_PATH;
  static MISSING_TGT_ID = 'Missing tgtId';
  bankDetails;
  user;
  SIMPLE_USER_ACCOUNT = {
    CONTRACT_PREFIX: '200',
    LOGIN_TYPE: 'BBOX_SECONDAIRE'
  };
  userSubject = new Subject();
  shouldShowSirenStep = false;
  _storageKey = 'customer';
  static LIMITED_RANGE = [LimitedCommercialSeries.B_AND_YOU];
  productService = inject(ProductService);
  oauthService = inject(CheckoutOauth2ResourcesService);
  oauth2Service = inject(Oauth2Service);
  configService = inject(ConfigurationService);
  checkoutStorage = inject(CheckoutStorageService);
  constructor() {
    this.user = new User();
    this.oauth2Service.afterLogout.subscribe(() => {
      this.logout();
    });
    // @todo move in app
    UserService.SIGNUP_PATH = '/tunnel/coordonnees';
  }
  logout() {
    this.deleteStorage();
  }
  get loginUrl() {
    const loginUrl = this.configService.getData().picasso.login;
    const originUrl = this.configService.getData().origin;
    return `${loginUrl}?service=${originUrl}${UserService.SIGNUP_PATH}/&tmpl=sale`;
  }
  createProspect(data) {
    const prospectObs = this.oauthService.useSalesApi().setLocalService().ventes().prospectWEB().displayErrors().post(data);
    const sessionObs = this.user.session ? of(this.user.session) : prospectObs;
    return sessionObs.pipe(mergeMap(session => {
      this.user.session = session;
      this.user.id = session.noPersonne;
      if (!session.tgtId) {
        console.log('Error: Missing tgtId session', session);
        throw new Error(UserService.MISSING_TGT_ID);
      }
      return this.oauth2Service.loginWithTgtId(session.tgtId).pipe(catchError(error => {
        console.error('Error tgtId login', error);
        throw new Error(UserService.ERROR_TYPES.LOGIN);
      }));
    }), map(() => false), tap(() => this.oauth2Service.redirectToAuthorize()));
  }
  editProspect(url, data) {
    return this.oauthService.useSalesApi().setLocalService().setUrl(url).put(data).pipe(tap(() => this.user.updateData(data)), map(() => true));
  }
  getStoredUserData() {
    return this.checkoutStorage.get(this._storageKey);
  }
  deleteStorage() {
    this.checkoutStorage.remove(this._storageKey);
  }
  mapUserDataToStorageData() {
    if (!this.user?.id) {
      return {};
    }
    return {
      email: this.user.mainEmail?.email,
      civilite: this.user.civilite === 'M' ? USER_TITLES.mister : this.user.civilite,
      nom: this.user.nom,
      prenom: this.user.prenom,
      departementNaissance: this.user.codeDepartementNaissance,
      dateNaissance: frontFormatToApiVente(refCliFormatToFrontFormat(this.user.dateNaissance)),
      telephone: this.user.mainPhone?.numero.replace(/^0/, '+33')
    };
  }
  save(userData) {
    const currentUserData = this.getStoredUserData();
    this.checkoutStorage.set(this._storageKey, {
      ...currentUserData,
      ...userData
    });
  }
  signupData() {
    return this._getPersonResourceUri().pipe(mergeMap(personResourceUrl => {
      this._setSirenDataFromStorage();
      if (personResourceUrl && this.oauth2Service.updateIsConnected()) {
        return this._getPersonData(personResourceUrl);
      }
      return this.oauth2Service.autoLogin().pipe(tap(() => this.oauth2Service.updateIsConnected()), mergeMap(() => this._getPersonResourceUri()), mergeMap(personUrl => {
        if (personUrl) {
          return this._getPersonData(personUrl);
        } else if (this.oauth2Service.isConnected) {
          return throwError({
            status: UserService.ERROR_TYPES.LOGIN
          });
        }
        return of(null);
      }));
    }));
  }
  getAddress() {
    if (this.user.address) {
      return this.user.address;
    }
    const customer = this.getStoredUserData();
    return customer && customer.address ? customer.address : null;
  }
  checkMailValidity(email) {
    return this.oauthService.useSalesApi().setLocalService().validationEmail().setParams({
      mail: email
    }).get().pipe(catchError(error => {
      console.warn(error);
      return of(null);
    }));
  }
  checkSirenValidity(siren, setSirenData = false) {
    return this.oauthService.useSalesApi().setLocalService().controleSiren(siren).addCache().get().pipe(tap(data => {
      if (setSirenData) {
        this.user.setSirenData(data);
        this.user.siren = siren;
      }
    }));
  }
  getInvoicingInfos(siren) {
    return this.oauthService.useSalesApi().setLocalService().invoicingInfo(siren).addCache().get().pipe(catchError(() => {
      return of(false);
    }), tap(data => {
      if (data) {
        this.user.invoicingInfo = data;
      }
    }));
  }
  getContractTerm(eligibilityData) {
    const contractDurationType = {
      MONTH12: {
        LABEL: RENEW_NB_TERMS.MONTH12,
        DIFF: 0
      },
      MONTH18: {
        LABEL: RENEW_NB_TERMS.MONTH18,
        DIFF: 6
      },
      MONTH24: {
        LABEL: RENEW_NB_TERMS.MONTH24,
        DIFF: 12
      }
    };
    const eligforCastRenewalData = eligibilityData?.items[0];
    let renewalContractTerm = contractDurationType.MONTH12.LABEL;
    const currentDate = new Date();
    const date24 = new Date(eligforCastRenewalData?.dateTarifPreferentiel);
    const date18 = new Date(eligforCastRenewalData?.dateTarifPreferentielIntermediaire);
    if (currentDate > date24) {
      renewalContractTerm = contractDurationType.MONTH24.LABEL;
    } else if (currentDate > date18) {
      renewalContractTerm = contractDurationType.MONTH18.LABEL;
    }
    return renewalContractTerm;
  }
  isUserTypeCdc() {
    const personInfo = this.oauth2Service.getPersonInfo();
    if (personInfo) {
      return UserService.CDC_TYPES.includes(personInfo.user_type);
    }
    return false;
  }
  getUserFirstName() {
    return this.oauth2Service.getPersonInfo().given_name;
  }
  /**
   * Asynchronous method to check if the user is eligible for a limited range
   * @param cart Current Cart
   * @returns Promise<boolean>
   */
  async isUserEligibleLimitedRange(cart) {
    const quoteFix = cart.quotes.find(q => q.context.id === QUOTE_CONTEXTS.ACQUISITIONFIX);
    if (!quoteFix) {
      return true;
    }
    const plan = quoteFix.getPrincipalProduct(Plan);
    if (plan && ProductFactory.Is(plan, Fai, true) && UserService.LIMITED_RANGE.includes(plan.data.commercial_series)) {
      const user = this.user;
      const activeContracts = user.contracts?.filter(contract => contract.statut === CONTRACT_STATUS.ACTIVE);
      return await this.isRangeEligible(plan.data.commercial_series, activeContracts, cart);
    }
    return true;
  }
  async canSubscribeToFai(addressToCheck) {
    const faiContracts = this.user.contracts?.filter(contract => contract.ligneMarche === LIGNE_MARCHE.FAI && contract.statut === CONTRACT_STATUS.ACTIVE);
    if (!faiContracts?.length) {
      return true;
    }
    for (const contract of faiContracts) {
      const contractLines = await lastValueFrom(this.oauthService.setUrl(contract._links.lignes?.href).get());
      for (const line of contractLines.items) {
        const installAddress = await lastValueFrom(this.oauthService.setUrl(line._links['adresse-installation']?.href).get());
        if (addressToCheck.inseeCode === installAddress.codeInsee && addressToCheck.hexaKey === installAddress.hexacle && addressToCheck.postalCode === installAddress.codePostal && addressToCheck.rivoliCode === installAddress.codeRivoli) {
          return false;
        }
      }
    }
    return true;
  }
  async isRangeEligible(range, contracts, cart) {
    let productsToCheck = [];
    // Prospect panier mixte
    if ((!contracts?.length || contracts?.every(c => c.ligneMarche === LIGNE_MARCHE.FAI)) && cart.isMixed()) {
      const mobileQuote = cart.quotes.find(q => q.context.id === QUOTE_CONTEXTS.ACQUISITION);
      const plan = mobileQuote?.getPrincipalProduct(Plan);
      if (plan) {
        productsToCheck.push(plan);
      }
    } else if (contracts?.length > 0) {
      productsToCheck = await lastValueFrom(this.productService.getProductsByGencodes(contracts.map(contract => contract.abonnement.idOffre)));
    }
    if (productsToCheck.length) {
      switch (range) {
        case LimitedCommercialSeries.B_AND_YOU:
          return productsToCheck?.some(product => !product.data.obligation && (product.data.type_id === 'plan_sowo' || product.data.type_id === 'plan_sowo_renew'));
        default:
          return false;
      }
    }
    return false;
  }
  _getPersonResourceUri() {
    if (this.user.renewContractId) {
      return this.oauthService.contracts(this.user.renewContractId).get().pipe(tap(contract => this._setContracts([contract])), map(data => data._links.titulaire.href));
    }
    const personInfo = this.oauth2Service.getPersonInfo();
    const resourceUri = personInfo?.id_personne ? `/personnes/${personInfo.id_personne}` : null;
    return of(resourceUri);
  }
  _getUserAddress() {
    const address = this.getAddress();
    if (this.user.defaultContract) {
      const compteFacturation = this.user.defaultContract._links?.compteFacturation?.href;
      if (compteFacturation) {
        return this.oauthService.setUrl(compteFacturation).get().pipe(mergeMap(res => {
          const adresseFacturation = res?._links?.adresseFacturation?.href;
          this.bankDetails = res?.compteBancaire || null;
          this.user.paymentMethod = res.modePaiement;
          return adresseFacturation ? this.oauthService.setUrl(adresseFacturation).get() : of({});
        }), map(res => this.user.address = address || this._mapToAddress(res)));
      }
    } else if (this.user.contactDetails?.adressesPostales?.length) {
      this.user.address = this._mapToAddress(this.user.contactDetails.adressesPostales[0]);
    }
    return of(null);
  }
  _setContracts(contracts) {
    this.user.contracts = contracts;
    this._setDefaultContract(contracts);
  }
  _setDefaultContract(contracts) {
    let defaultContract = contracts.find(contract => this._defaultContractPredicate(contract, LIGNE_MARCHE.FNB));
    if (!defaultContract) {
      defaultContract = contracts.find(contract => this._defaultContractPredicate(contract, LIGNE_MARCHE.FAI));
    }
    this.user.defaultContract = defaultContract;
  }
  _defaultContractPredicate(contract, type) {
    return contract.statut === CONTRACT_STATUS.ACTIVE && contract.ligneMarche === type;
  }
  _getPersonData(personResourceUrl) {
    let userLevelsData;
    return this.oauthService.setUrl(personResourceUrl).get().pipe(mergeMap(user => {
      if (user.idPersonneIdentifiee?.startsWith(this.SIMPLE_USER_ACCOUNT.CONTRACT_PREFIX) || this.oauth2Service.getPersonInfo()?.login_type === this.SIMPLE_USER_ACCOUNT.LOGIN_TYPE) {
        return throwError({
          status: UserService.ERROR_TYPES.UNAUTHORIZED
        });
      }
      if (!user.siren) {
        this.user.deleteSirenData();
        this._deleteSirenDataFromStorage();
      }
      this.user.setData(user);
      const personnesLevelsdata = {
        contracts: this._getContracts(),
        contactDetails: this._getContactCoordinate()
      };
      if (user.siren) {
        personnesLevelsdata.siren = this.checkSirenValidity(user.siren, false);
        this.getInvoicingInfos(user.siren).subscribe({
          next: invoicingData => {
            if (invoicingData) {
              this.shouldShowSirenStep = true;
            }
          },
          error: error => {
            console.error('SirenComponent: Error loading invoicing data', error);
          }
        });
      }
      return forkJoin(personnesLevelsdata).pipe(tap(data => {
        if (user.id !== this.user.id) {
          this.checkoutStorage.clearTag(STORAGE_TAGS.CUSTOMER);
        }
        this.user.setData({
          ...user,
          typeContrats: this._getContractType(data.contracts)
        });
      }));
    }), mergeMap(data => {
      userLevelsData = data;
      this.user.contactDetails = data.contactDetails;
      if (data.siren && this.user.siren) {
        this.save({
          siren: {
            id: this.user.siren,
            data: data.siren
          }
        });
      }
      this.userSubject.next(this.user);
      return this._getUserAddress();
    }), mergeMap(() => of(userLevelsData)));
  }
  _getContracts() {
    if (this.user.renewContractId) {
      return of(this.user.contracts);
    }
    const contractsHref = this.user?._links?.contratsSignes?.href;
    if (contractsHref) {
      return this.oauthService.setUrl(contractsHref).get().pipe(map(result => result.items.sort(dateSorter)), tap(contracts => {
        this._setContracts(contracts);
      }), mergeMap(contracts => of(contracts)));
    }
    return of([]);
  }
  _getContactCoordinate() {
    const coordonneesContact = this.user?._links?.coordonneesContact?.href;
    return coordonneesContact ? this.oauthService.setUrl(coordonneesContact).get() : of(null);
  }
  _mapToAddress(adressePostale) {
    return {
      codePostal: adressePostale.codePostal,
      rue: adressePostale.rue,
      ville: adressePostale.ville,
      numeroRue: adressePostale.numero,
      complementAdresse: adressePostale.complementAdresse1
    };
  }
  _setSirenDataFromStorage() {
    const storedSirenData = this.getStoredUserData()?.siren?.data;
    this.user.setSirenData(storedSirenData);
  }
  _deleteSirenDataFromStorage() {
    const storedUserData = this.getStoredUserData();
    if (storedUserData) {
      delete storedUserData.siren;
      this.save(storedUserData);
    }
  }
  _getContractType(userContrats) {
    let aggregatedContractType = CONTRACT_TYPES.NONE;
    if (!userContrats) {
      return aggregatedContractType;
    }
    const ACTIVE_CONTRACT_TYPES = {
      [CONTRACT_TYPES.FNB]: false,
      [CONTRACT_TYPES.FAI]: false,
      [CONTRACT_TYPES.FAI_PREMIUM]: false
    };
    const contracts = userContrats;
    for (const contract of contracts) {
      const isTokyo = contract.ligneMarche === `${CONTRACT_TYPES.FNB}` && contract.abonnement.offreTokyo;
      const isPremiumSubscription = contract.abonnement.offrePremium;
      switch (true) {
        case isTokyo && isPremiumSubscription:
          ACTIVE_CONTRACT_TYPES.FAI_PREMIUM = true;
          break;
        case isTokyo && !isPremiumSubscription:
          ACTIVE_CONTRACT_TYPES.FAI = true;
          break;
        case contract.ligneMarche === `${CONTRACT_TYPES.FAI}` && isPremiumSubscription:
          ACTIVE_CONTRACT_TYPES.FAI_PREMIUM = true;
          break;
        default:
          ACTIVE_CONTRACT_TYPES[contract.ligneMarche] = true;
      }
    }
    switch (true) {
      case ACTIVE_CONTRACT_TYPES.FAI_PREMIUM && ACTIVE_CONTRACT_TYPES.FNB:
        aggregatedContractType = CONTRACT_TYPES.FAI_PREMIUM_FNB;
        break;
      case ACTIVE_CONTRACT_TYPES.FAI && ACTIVE_CONTRACT_TYPES.FNB:
        aggregatedContractType = CONTRACT_TYPES.FAI_FNB;
        break;
      case ACTIVE_CONTRACT_TYPES.FAI_PREMIUM:
        aggregatedContractType = CONTRACT_TYPES.FAI_PREMIUM;
        break;
      case ACTIVE_CONTRACT_TYPES.FAI:
        aggregatedContractType = CONTRACT_TYPES.FAI;
        break;
      case ACTIVE_CONTRACT_TYPES.FNB:
        aggregatedContractType = CONTRACT_TYPES.FNB;
        break;
      default:
        console.warn('Unknown contract type');
    }
    return aggregatedContractType;
  }
  static ɵfac = function UserService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || UserService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: UserService,
    factory: UserService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let QuoteContextFactory = /*#__PURE__*/(() => {
  class QuoteContextFactory {
    oauthService;
    oauth2;
    userService;
    productService;
    CONTEXT_TYPE = [QuoteContextAcquisitionModel, QuoteContextRenewalModel, QuoteContextFaiModel];
    _contractId;
    constructor(oauthService, oauth2, userService, productService) {
      this.oauthService = oauthService;
      this.oauth2 = oauth2;
      this.userService = userService;
      this.productService = productService;
    }
    initContextFromStorage(quoteContext) {
      const currentContext = this.CONTEXT_TYPE.find(searchContext => {
        const contextModel = new searchContext();
        return contextModel.id === quoteContext.id;
      });
      return new currentContext(quoteContext);
    }
    createContext(context, params) {
      const contextModel = new context();
      switch (contextModel.id) {
        case QUOTE_CONTEXTS$1.RENEW:
          return this._initContextRenewal(params.contractId).pipe(map(data => new QuoteContextRenewalModel(data)));
        case QUOTE_CONTEXTS$1.ACQUISITIONFIX:
          return of(new QuoteContextFaiModel());
        default:
          return of(new QuoteContextAcquisitionModel());
      }
    }
    _initContextRenewal(contractId) {
      this._contractId = contractId;
      return this.oauth2.autoLogin().pipe(mergeMap(() => forkJoin([this._getLines(), this._getContract(), this._getOption(), this._getCodeTac(), this._getRenewEligibility().pipe(map(eligibilityData => this.userService.getContractTerm(eligibilityData)))])), map(([lignes, contract, options, codeTac, nbTerms]) => ({
        phone: lignes?.items?.length ? lignes.items[0].numeroTel.replace('+33', '0') : '',
        contractId: this._contractId,
        currentPlan: contract.abonnement.idOffre,
        options,
        codeTac: codeTac?.mobileUsage?.codeTac,
        clientType: contract.contratCollaborateur ? RENEW_CLIENT_TYPES.COLLABORATOR : RENEW_CLIENT_TYPES.CLIENT,
        nbTerms: contract.isSowo ? null : nbTerms
      })));
    }
    _getLines() {
      return this.oauthService.contracts(this._contractId).lignes().addCache().get().pipe(catchError(() => of(false)));
    }
    _getCodeTac() {
      return this.oauthService.contracts(this._contractId).addCache().mobileUsage().get().pipe(catchError(() => of(false)));
    }
    _getContract() {
      return this.oauthService.contracts(this._contractId).addCache().get().pipe(mergeMap(data => {
        const currentPlanGencode = data.abonnement.idOffre;
        return this.productService.getProductByGencode(currentPlanGencode).pipe(map(product => {
          data.isSowo = ProductFactory.Is(product, Sowo);
          return data;
        }));
      }), catchError(() => of(false)));
    }
    _getOption() {
      return this.oauthService.contracts(this._contractId).options().addCache().get().pipe(map(data => data.items), catchError(() => of([])));
    }
    _getRenewEligibility() {
      return this.oauthService.contracts(this._contractId).eligibilitesRenouvellement().get().pipe(catchError(error => {
        console.warn(error);
        return of(null);
      }));
    }
    static ɵfac = function QuoteContextFactory_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || QuoteContextFactory)(i0.ɵɵinject(CheckoutOauth2ResourcesService), i0.ɵɵinject(Oauth2Service), i0.ɵɵinject(UserService), i0.ɵɵinject(ProductService));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: QuoteContextFactory,
      factory: QuoteContextFactory.ɵfac,
      providedIn: 'root'
    });
  }
  return QuoteContextFactory;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CartRepository = /*#__PURE__*/(() => {
  class CartRepository {
    _storageKey = 'cart';
    checkoutStorage = inject(CheckoutStorageService);
    quoteContextFactory = inject(QuoteContextFactory);
    saveCart(cartModel) {
      const currentCart = this.getCart();
      const quotesData = cartModel.quotes.map(quote => this._getDataToStore(quote));
      const cartData = {
        ...currentCart,
        cartId: cartModel.cartId,
        coupon: cartModel.coupon,
        type: cartModel.type,
        userId: cartModel.userId,
        currentQuote: cartModel.currentQuoteIndex,
        quotes: quotesData,
        isPro: cartModel.isPro,
        isComingFromProWall: cartModel.isComingFromProWall,
        lastProductParamsSent: cartModel.lastProductParamsSent,
        promotions: cartModel.promotions,
        fundingMethod: cartModel.fundingMethod
      };
      this.checkoutStorage.set(this._storageKey, cartData);
    }
    getCart() {
      const cart = this.checkoutStorage.get(this._storageKey);
      if (!cart) {
        // panier expiré => clear storage
        this.checkoutStorage.clear();
      }
      return cart;
    }
    initCartFromStorage(cartModel) {
      const storageCart = this.getCart();
      if (!storageCart) {
        return false;
      }
      this.setCartBasicProperties(cartModel, storageCart);
      this.setCartPromotions(cartModel, storageCart);
      this.setCartQuotes(cartModel, storageCart);
      return true;
    }
    setCartBasicProperties(cartModel, storageCart) {
      cartModel.cartId = storageCart.cartId;
      cartModel.coupon = storageCart.coupon;
      cartModel.type = storageCart.type;
      cartModel.userId = storageCart.userId;
      cartModel.configId = storageCart.configId || '';
      cartModel.currentQuoteIndex = storageCart.currentQuote;
      cartModel.isPro = storageCart.isPro;
      cartModel.isComingFromProWall = storageCart.isComingFromProWall;
      cartModel.lastProductParamsSent = storageCart.lastProductParamsSent;
      cartModel.fundingMethod = storageCart.fundingMethod;
    }
    setCartPromotions(cartModel, storageCart) {
      const promosManual = storageCart.promotions.manual.map(promo => new PromotionModel(promo));
      const coupon = storageCart.promotions.coupon ? new PromotionModel(storageCart.promotions.coupon) : null;
      cartModel.promotions = new PromotionsModel([], promosManual, [], coupon);
    }
    setCartQuotes(cartModel, storageCart) {
      if (!storageCart.quotes) {
        return;
      }
      storageCart.quotes.forEach(cartQuote => {
        const quote = this.createQuoteFromStorage(cartQuote);
        cartModel.quotes.push(quote);
      });
      this.handleMixedCartContext(cartModel);
    }
    createQuoteFromStorage(cartQuote) {
      const quoteContext = this.quoteContextFactory.initContextFromStorage(cartQuote.context);
      const quote = new QuoteModel({
        id: cartQuote.id,
        products: [],
        context: quoteContext,
        address: cartQuote.address,
        forms: cartQuote.forms || {},
        lastProductParamsSent: cartQuote.lastProductParamsSent
      });
      this.setQuoteProducts(quote, cartQuote.products);
      this.adjustContextForFaiProducts(quote, quoteContext);
      return quote;
    }
    setQuoteProducts(quote, products) {
      products.forEach(product => {
        const productInstance = ProductFactory.GetInstance(product.data);
        if (productInstance) {
          productInstance.id = product.id;
          this.setProductData(product, productInstance);
          quote.products.push(productInstance);
        }
      });
    }
    adjustContextForFaiProducts(quote, quoteContext) {
      const hasFaiProducts = quote.products.some(product => ProductFactory.Is(product, Fai));
      if (hasFaiProducts && quoteContext.id !== QUOTE_CONTEXTS.ACQUISITIONFIX) {
        quoteContext.id = QUOTE_CONTEXTS.ACQUISITIONFIX;
      }
    }
    handleMixedCartContext(cartModel) {
      if (cartModel.quotes.length <= 1) {
        return;
      }
      const quotes = cartModel.quotes;
      const initialContextId = quotes[0].context.id;
      const isValidAcquisitionContext = initialContextId === QUOTE_CONTEXTS.ACQUISITION || initialContextId === QUOTE_CONTEXTS.ACQUISITIONFIX;
      const allQuotesHaveSameContext = quotes.every(quote => quote.context.id === initialContextId);
      if (isValidAcquisitionContext && allQuotesHaveSameContext) {
        cartModel.quotes = [quotes[0]];
      }
    }
    setProductData(source, target) {
      const keys = Object.keys(source);
      keys.forEach(key => {
        target[key] = source[key];
      });
      if (target.promotions) {
        target.promotions = new PromotionsModel(target.promotions.automatic, target.promotions.manual, target.promotions.incitation, target.promotions.coupon);
      }
    }
    _getDataToStore(quote) {
      return {
        address: quote.address,
        context: quote.context.getData(),
        forms: quote.forms,
        id: quote.id,
        products: quote.products,
        lastProductParamsSent: quote.lastProductParamsSent
      };
    }
    static ɵfac = function CartRepository_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CartRepository)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CartRepository,
      factory: CartRepository.ɵfac,
      providedIn: 'root'
    });
  }
  return CartRepository;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FaiRepository = /*#__PURE__*/(() => {
  class FaiRepository {
    checkoutStorage;
    constructor(checkoutStorage) {
      this.checkoutStorage = checkoutStorage;
    }
    getEligibility() {
      return this.checkoutStorage.get('eligibility', false);
    }
    static ɵfac = function FaiRepository_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FaiRepository)(i0.ɵɵinject(CheckoutStorageService));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FaiRepository,
      factory: FaiRepository.ɵfac,
      providedIn: 'root'
    });
  }
  return FaiRepository;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FundingRepository = /*#__PURE__*/(() => {
  class FundingRepository {
    CREDIT_TYPE_MAP = {
      3: {
        [FUNDING_ENUM.COFIDIS]: FUNDING_ENUM.COFIDIS_X3,
        [FUNDING_ENUM.SWAPPY]: FUNDING_ENUM.SWAPPY_X3,
        default: FUNDING_ENUM.YOUNITED_X3
      },
      12: {
        [FUNDING_ENUM.COFIDIS]: FUNDING_ENUM.COFIDIS_X12,
        [FUNDING_ENUM.SWAPPY]: FUNDING_ENUM.SWAPPY_X12,
        default: FUNDING_ENUM.YOUNITED_X12
      },
      24: {
        [FUNDING_ENUM.COFIDIS]: FUNDING_ENUM.COFIDIS_X24,
        [FUNDING_ENUM.SWAPPY]: FUNDING_ENUM.SWAPPY_X24,
        default: FUNDING_ENUM.YOUNITED_X24
      },
      36: {
        [FUNDING_ENUM.SWAPPY]: FUNDING_ENUM.SWAPPY_X36,
        default: FUNDING_ENUM.YOUNITED_X36
      }
    };
    DEFAULT_CREDIT_TYPE_MAP = {
      [FUNDING_ENUM.COFIDIS]: FUNDING_ENUM.COFIDIS,
      [FUNDING_ENUM.SWAPPY]: FUNDING_ENUM.SWAPPY,
      default: FUNDING_ENUM.YOUNITED
    };
    PAYMENT_MODES_DETAILS = [{
      id: 'CB',
      value: 'CB',
      icon: 'credit-card',
      position: 0
    }, {
      id: 'PAYPAL',
      value: 'PAYPAL',
      icon: 'icon-cb-paypal',
      position: 1
    }, {
      id: 'COFIDIS_X3',
      value: 'CREDIT_X3',
      label: 'Paiement en 3 fois sans frais'
    }, {
      id: 'COFIDIS_X12',
      value: 'CREDIT_MENSUEL'
    }, {
      id: 'COFIDIS_X24',
      value: 'CREDIT_MENSUEL'
    }, {
      id: 'YOUNITED',
      value: 'YOUNITED'
    }, {
      id: 'HYBRIDE',
      value: 'HYBRIDE',
      position: 4
    }, {
      id: 'SANS_PAIEMENT',
      value: 'SANS_PAIEMENT'
    }, {
      id: 'EDP',
      value: 'EDP'
    }];
    FUNDING_COOKIE = 'younited_credit';
    YOUNITED_UNWANTED_KEY = ['YOUNITED_X3', 'YOUNITED_X12', 'YOUNITED_X24', 'YOUNITED_X36'];
    SWAPPY_KEY = ['REPRISE_GARANTIE_YOUNITED_X12', 'REPRISE_GARANTIE_YOUNITED_X24', 'REPRISE_GARANTIE_YOUNITED_X36'];
    COFIDIS_UNWANTED_KEY = ['COFIDIS_X12', 'COFIDIS_X24', 'COFIDIS_X3'];
    oauth2Resource = inject(Oauth2ResourcesService);
    cookieStorageService = inject(CookieStorageService);
    userService = inject(UserService);
    document = inject(DOCUMENT);
    /**
    * Get funding modes for current cart
    * @param cartId Current cart id
    * @returns Fundings modes
    */
    getFundingCart(cartId) {
      const ressource = this.oauth2Resource.ventes().panier(cartId).modesFinancement().useSalesApi();
      if (this._getFundingCookie()) {
        ressource.setParams({
          younited_credit: this._getFundingCookie()
        });
      }
      ressource.setParams({
        mode: 'min-one-off'
      });
      return ressource.get().pipe(map(response => this._createFundingCartModel(response)));
    }
    /**
     * Get funding modes for virtual cart - before real call in payment page
     * @param payload payload for post
     * @returns FundingCart
     * TODO: Make interface for post response
     */
    getVirtualCartFundingModes(cartModel, idPu) {
      if (cartModel.isCartEmpty()) {
        return null;
      }
      const ressource = this.oauth2Resource.modesFinancementVirtuel().useSalesApi().addCache();
      if (this._getFundingCookie()) {
        ressource.setParams({
          younited_credit: this._getFundingCookie()
        });
      }
      ressource.setParams({
        mode: 'min-one-off'
      });
      return ressource.post(this._getVirtualFundingModesPayload(cartModel, idPu)).pipe(map(response => this._createFundingCartModel(response?.financements[0])));
    }
    /**
     * Get current funding method with final commercial proposal
     * @param cartId current cartId
     * @returns return final proposal
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getCurrentFundingMethod(cartId) {
      return this.oauth2Resource.ventes().panier(cartId).modesFinancement().courant().useSalesApi().addCache().get().pipe(map(result => this._createCurrentFunding(result)));
    }
    /**
     * Post funding modes
     * @returns FundingModeReturn object
     */
    postFundingMode(cartModel, fundingCart, paymentMode, proposal) {
      let modeDeFinancement = cartModel.fundingMethod?.type;
      if (proposal) {
        modeDeFinancement = this._getCreditType(cartModel.fundingMethod?.type, proposal.nbLoan).toString();
      }
      const params = {
        modeDeFinancement,
        modeDePaiement: this._getPaymentMode(paymentMode, cartModel.fundingMethod, proposal?.nbLoan),
        urlDeRappel: `${this.document.location.origin}/tunnel/redirect?cartId=${cartModel.cartId}`,
        parcours: cartModel.fundingMethod?.type === FUNDING_ENUM.MULTI_PRODUCT ? fundingCart.pathway.map(pw => this._getFundingPathwayApi(cartModel, pw)) : null
      };
      if (!params.modeDeFinancement || !params.modeDePaiement) {
        throw new Error('Mode de financement ou de paiement manquant');
      }
      const ressource = this.oauth2Resource.ventes().panier(cartModel.cartId).modesFinancement().useSalesApi();
      if (this._getFundingCookie()) {
        ressource.setParams({
          younited_credit: this._getFundingCookie()
        });
      }
      return ressource.post(params).pipe(map(result => ({
        status: result.status,
        callbackUrl: result.url,
        id: result.id
      })));
    }
    _createFundingCartModel(data) {
      if (!data) {
        return null;
      }
      const fundingCart = new FundingCart({
        idCart: data.idPanier,
        fundingMethods: this._createFundingModeModel(data),
        pathway: data.parcours?.map(p => this._createFundingPathway(p))
      });
      const swappyMethods = fundingCart.fundingMethods.filter(fm => this.SWAPPY_KEY.some(key => key === fm.type));
      if (swappyMethods.length > 0) {
        const swappy = this._mergeYounitedProposals(swappyMethods, true);
        fundingCart.fundingMethods.push(swappy);
        fundingCart.fundingMethods = fundingCart.fundingMethods.filter(fm => !this.SWAPPY_KEY.includes(fm.type));
      }
      const younitedMethods = fundingCart.fundingMethods.filter(fm => this.YOUNITED_UNWANTED_KEY.some(key => key === fm.type));
      if (younitedMethods.length > 0) {
        const younited = this._mergeYounitedProposals(younitedMethods);
        fundingCart.fundingMethods.push(younited);
        fundingCart.fundingMethods = fundingCart.fundingMethods.filter(fm => !this.YOUNITED_UNWANTED_KEY.includes(fm.type));
      }
      const cofidisMethods = fundingCart.fundingMethods.filter(fm => this.COFIDIS_UNWANTED_KEY.some(key => key === fm.type));
      if (cofidisMethods.length > 0) {
        const cofidis = this._mergeCofidisProposals(cofidisMethods);
        fundingCart.fundingMethods.push(cofidis);
        fundingCart.fundingMethods = fundingCart.fundingMethods.filter(fm => !this.COFIDIS_UNWANTED_KEY.includes(fm.type));
      }
      return fundingCart;
    }
    _mergeYounitedProposals(methods, isSwappy = false) {
      let younitedMethod = new FundingMethod({
        type: isSwappy ? FUNDING_ENUM.SWAPPY : FUNDING_ENUM.YOUNITED,
        commercialProposal: [],
        label: this._getFundingMethodLabel(FUNDING_ENUM.SWAPPY),
        fullLabel: FUNDING_METHODS_DETAILS[FUNDING_ENUM.SWAPPY].fullLabel,
        paymentModes: methods[0]?.paymentModes,
        position: 2
      });
      methods.forEach(method => {
        method.commercialProposal.forEach(cp => {
          if (!younitedMethod.commercialProposal.find(el => el.nbLoan === cp.nbLoan)) {
            younitedMethod.commercialProposal.push(cp);
          }
        });
      });
      if (younitedMethod.commercialProposal.every(younitedMethod => younitedMethod.tAEG === 0)) {
        younitedMethod.label += ' 0%';
      }
      return younitedMethod;
    }
    _mergeCofidisProposals(methods) {
      let cofidisMethod = new FundingMethod({
        type: FUNDING_ENUM.COFIDIS,
        commercialProposal: [],
        label: this._getFundingMethodLabel(FUNDING_ENUM.COFIDIS),
        fullLabel: FUNDING_METHODS_DETAILS[FUNDING_ENUM.COFIDIS].fullLabel,
        paymentModes: [],
        position: 2
      });
      methods.forEach(method => {
        method.commercialProposal.forEach(cp => {
          if (!cofidisMethod.commercialProposal.find(el => el.nbLoan === cp.nbLoan)) {
            cofidisMethod.commercialProposal.push(cp);
          }
        });
      });
      return cofidisMethod;
    }
    _createFundingPathway(data) {
      return {
        idPathway: data.idParcours,
        products: data.produits?.map(p => this._createFundingPathwayProduct(p))
      };
    }
    _createFundingPathwayProduct(data) {
      return {
        idProduct: data.idProduit,
        gencode: data.gencode,
        cartFundingModes: data.modesDeFinancementPanier,
        productsFundingMode: data.modesDeFinancementProduits?.map(method => {
          return new FundingMethod({
            label: this._getFundingMethodLabel(method.type) ?? method?.libelle,
            paymentModes: this._createPaymentModes(method.modesDePaiement),
            commercialProposal: this._createCommercialProposals(method?.propositionsCommerciales),
            type: method?.type
          });
        })
      };
    }
    /**
     * Transform api data to funding mode model
     * @param data API data
     * @returns Return funding mode model
     */
    _createFundingModeModel(data) {
      return data.modesDeFinancement?.map(method => {
        return new FundingMethod({
          label: this._getFundingMethodLabel(method.type) ?? method?.libelle,
          paymentModes: this._createPaymentModes(method.modesDePaiement),
          commercialProposal: this._createCommercialProposals(method?.propositionsCommerciales),
          type: method?.type,
          position: this._getFundingMethodPosition(method)
        });
      });
    }
    _createPaymentModes(paymentModes) {
      return paymentModes?.map(mp => this.PAYMENT_MODES_DETAILS.find(el => el.id === mp.type)).filter(mp => mp);
    }
    /**
     * Create commercial proposal array - for younited in case of multiple proposal
     * for same duration take the on with the cheapest initialAmount
     * @param data api proposals
     * @returns commercial proposal array
     */
    _createCommercialProposals(data) {
      const proposals = [];
      if (!data) {
        return proposals;
      }
      data.forEach(cp => {
        const proposal = {
          initialAmount: cp?.apportInitial,
          fundingFinalCost: cp?.coutTotalFinancement,
          amountToFund: cp?.montantAFinancer,
          interestAmount: cp?.montantInterets,
          monthlyAmount: cp?.montantMensualite,
          lastMonthlyAmount: cp?.dernierMontantMensualite,
          nbLoan: cp?.nbrEcheances,
          tAEG: cp?.tAEG,
          fixedRate: cp?.tauxDebiteurFixe
        };
        proposals.push(proposal);
      });
      return proposals;
    }
    /**
     * Create funding method from get current API response
     * @param data api response
     * @returns Current funding method with partner status
     */
    _createCurrentFunding(data) {
      return {
        id: data.id,
        method: new FundingMethod({
          label: this._getFundingMethodLabel(data.modesDeFinancement?.type) ?? data.modesDeFinancement?.libelle,
          paymentModes: this.PAYMENT_MODES_DETAILS.filter(pm => pm.id === data.modesDeFinancement?.modesDePaiement),
          commercialProposal: data.status?.toLowerCase() === 'ok' ? [{
            initialAmount: data.modesDeFinancement?.propositionsCommerciales?.apportInitial,
            fundingFinalCost: data.modesDeFinancement?.propositionsCommerciales?.coutTotalFinancement,
            amountToFund: data.modesDeFinancement?.propositionsCommerciales?.montantAFinancer,
            interestAmount: data.modesDeFinancement?.propositionsCommerciales?.montantInterets,
            monthlyAmount: data.modesDeFinancement?.propositionsCommerciales?.montantMensualite,
            lastMonthlyAmount: data.modesDeFinancement?.propositionsCommerciales?.dernierMontantMensualite,
            nbLoan: data.modesDeFinancement?.propositionsCommerciales?.nbrEcheances,
            tAEG: data.modesDeFinancement?.propositionsCommerciales?.tAEG,
            fixedRate: data.modesDeFinancement.propositionsCommerciales.tauxDebiteurFixe
          }] : null,
          type: data.modesDeFinancement?.type
        }),
        status: data.status,
        reason: data.raison
      };
    }
    _getFundingMethodLabel(type) {
      return FUNDING_METHODS_DETAILS[type]?.label ?? null;
    }
    _getFundingCookie() {
      return this.cookieStorageService.get(this.FUNDING_COOKIE) ?? null;
    }
    _getFundingPathwayApi(cartModel, data) {
      return {
        idParcours: data.idPathway,
        produits: this._getFundingProductPostApi(cartModel, data)
      };
    }
    _getFundingProductPostApi(cartModel, data) {
      const selectedFundingMethod = cartModel.fundingMethod;
      let edpProduct = null;
      const products = [];
      if (selectedFundingMethod.type === FUNDING_ENUM.MULTI_PRODUCT) {
        edpProduct = data.products.find(p => p.productsFundingMode.some(pfm => pfm.type === 'EDP'));
        products.push({
          idProduit: edpProduct.idProduct,
          modeDeFinancement: edpProduct.productsFundingMode.find(pfm => pfm.type === 'EDP').type
        });
      }
      return products;
    }
    /**
     * TODO: Find a better way to get payment mode - Sprint 10
     * @param paymentMode Selected payment mode ( form )
     * @param fundingMethod Current funding method
     * @returns payment mode as string
     */
    _getPaymentMode(paymentMode, fundingMethod, nbLoan = null) {
      if (fundingMethod?.type === FUNDING_ENUM.COFIDIS) {
        if (nbLoan && nbLoan === 2) {
          return 'CREDIT_X3';
        } else {
          return 'CREDIT_MENSUEL';
        }
      }
      // First check if funding is credit ( cofidis or younited )
      if (fundingMethod?.type !== FUNDING_ENUM.CASH && fundingMethod?.type !== FUNDING_ENUM.MULTI_PRODUCT) {
        return fundingMethod.paymentModes[0]?.value;
      }
      // Use value if selected
      if (paymentMode?.id) {
        return paymentMode.value;
      }
      throw new Error('La sélection du mode de paiement est obligatoire');
    }
    _getVirtualFundingModesPayload(cartModel, idPu) {
      return {
        paniers: [{
          parcours: cartModel.quotes.map(q => this._getVirtualQuoteApi(cartModel, idPu, q))
        }],
        utilisateur: {
          type: this.userService.isUserTypeCdc() ? USER_TYPE_API.CDC : USER_TYPE_API.CLIENT
        },
        totalImmediat: this._getTotalImmediat(cartModel)
      };
    }
    _getTotalImmediat(cartModel) {
      let totalImmediat = 0;
      cartModel.quotes.forEach(quote => {
        quote.products.forEach(product => {
          if (product.priceType === PRICE_TYPES$1.Today && product.prices.base > 0) {
            totalImmediat += product.prices.final || 0;
          }
        });
      });
      return totalImmediat;
    }
    _getVirtualQuoteApi(cartModel, idPu, quote) {
      return {
        client: {
          type: this._clientTypeTranslation(quote.context?.clientType ?? 'CLIENT'),
          categorie: cartModel.getCustomerCategory(),
          anciennete: this._nbTermsTranslation(quote.context?.nbTerms || RENEW_NB_TERMS.MONTH24),
          idContrat: +quote.context?.contractId || null,
          idPu
        },
        type: quote.context.id,
        produits: quote.products.map(p => this._getVirtualProductApi(quote, p))
      };
    }
    _getVirtualProductApi(quote, product) {
      const plan = quote.getProductByType(Plan);
      let productApi = {
        parentGencode: product.data.parent_code,
        gencode: product.gencode,
        prix: product.priceType !== 0 ? 0 : product.prices.final,
        prixOrigine: product.priceType !== 0 ? 0 : product.prices.base,
        eligibleCredit: product.data.eligible_credit,
        type: product.data.type_id
      };
      if (ProductFactory.Is(product, Phone)) {
        productApi.edpTerminalNu = {
          amount: product.data.edp_phone.amount,
          duration: product.data.edp_phone.duration,
          price: product.data.edp_phone.price
        };
        if (ProductFactory.Is(plan, Sensation)) {
          const edpPrices = product.getEdpData(quote);
          productApi.tarifications = {
            plans: {}
          };
          productApi.tarifications.plans[plan.gencode] = product.data.prices.plans[plan.gencode];
          productApi.prixOrigine = edpPrices?.price || productApi.prixOrigine;
        }
      }
      return productApi;
    }
    _getCreditType(type, nbLoan = 3 | 12 | 24 | 36) {
      // Cofidis has nbLoan - 1 because first loan has to be payed now
      if (type === FUNDING_ENUM.COFIDIS) {
        nbLoan++;
      }
      const loanMap = this.CREDIT_TYPE_MAP[nbLoan];
      if (loanMap) {
        return loanMap[type] || loanMap.default;
      }
      return this.DEFAULT_CREDIT_TYPE_MAP[type] || this.DEFAULT_CREDIT_TYPE_MAP.default;
    }
    _nbTermsTranslation(value) {
      switch (value) {
        case RENEW_NB_TERMS.MONTH12:
          return '12mois';
        case RENEW_NB_TERMS.MONTH18:
          return '18mois';
        case RENEW_NB_TERMS.MONTH24:
          return '24mois';
        default:
          return null;
      }
    }
    _clientTypeTranslation(value) {
      if (value === RENEW_CLIENT_TYPES.COLLABORATOR) {
        return 'collaborateur';
      }
      return 'client';
    }
    _getFundingMethodPosition(method) {
      switch (method.type) {
        case FUNDING_ENUM.CASH:
          return 1;
        case FUNDING_ENUM.MULTI_PRODUCT:
          return 3;
        case FUNDING_ENUM.YOUNITED:
        case FUNDING_ENUM.COFIDIS:
          return 2;
        default:
          break;
      }
    }
    static ɵfac = function FundingRepository_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FundingRepository)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FundingRepository,
      factory: FundingRepository.ɵfac,
      providedIn: 'root'
    });
  }
  return FundingRepository;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OptionsRepository = /*#__PURE__*/(() => {
  class OptionsRepository {
    oauthService;
    productRepositoryService;
    constructor(oauthService, productRepositoryService) {
      this.oauthService = oauthService;
      this.productRepositoryService = productRepositoryService;
    }
    getRenewOptions(quoteModel, plan, selectedoptions = null) {
      const context = quoteModel.context;
      const params = {
        idOffrePrincipale: plan.gencode,
        parcours: 'RENOUVELLEMENT'
      };
      if (selectedoptions && selectedoptions.length > 0) {
        params.idOffresAdditionnelles = selectedoptions.join(',');
      }
      return this.oauthService.useSalesApi().contracts(context.contractId).offresAdditionnellesSouscriptibles().setParams(params).addCache().get().pipe(mergeMap(data => {
        const gencodes = data.offresAdditionnelles.map(opt => opt.idOffre);
        return this.productRepositoryService.getProductsByGencodes(gencodes);
      }), catchError(() => of(null)));
    }
    getAcquisitionOptions(cartModel, plan, selectedoptions = null, idEligibility = null) {
      const body = {
        parcours: 'ACTIVATION',
        univers: ProductFactory.Is(plan, Fai, true) ? 'FIXE' : 'MOBILE',
        cibleClient: cartModel.getCustomerCategory(),
        offresPanier: {
          idAbonnement: plan.gencode
        }
      };
      if (idEligibility) {
        body.idPanierCommandeFixe = idEligibility;
      }
      if (selectedoptions && selectedoptions.length > 0) {
        body.offresPanier.options = selectedoptions;
      }
      return this.oauthService.referentiel().offres().optionsSouscriptibles().addCache().post(body).pipe(mergeMap(data => {
        const gencodes = data.offresSecondaires.map(opt => opt.idOption);
        const gencodesPerPages = gencodes.length ? gencodes.reduce((acc, cur, i) => {
          const idx = Math.floor(i / 20);
          const page = acc[idx] || (acc[idx] = []);
          page.push(cur);
          return acc;
        }, []) : [];
        return forkJoin(gencodesPerPages.map(page => this.productRepositoryService.getProductsByGencodes(page))).pipe(map$1(products => products.reduce((acc, curr) => [...acc, ...curr], [])));
      }), catchError(() => of(null)));
    }
    static ɵfac = function OptionsRepository_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OptionsRepository)(i0.ɵɵinject(CheckoutOauth2ResourcesService), i0.ɵɵinject(ProductRepository));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OptionsRepository,
      factory: OptionsRepository.ɵfac,
      providedIn: 'root'
    });
  }
  return OptionsRepository;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class SalesApiHelper {
  static InternalProductGencode = ['delivery', 'edp', ...Object.values(SHIPPING_MODES$1)];
  static IsCompatibleWithPromotions(product) {
    switch (true) {
      case ProductFactory.Is(product, Option):
      case ProductFactory.Is(product, Insurance):
        return false;
      default:
        return true;
    }
  }
  static GetCartGenericParams(cart, gencodes = []) {
    const quote = cart.getQuote();
    quote.products.forEach(product => {
      if (SalesApiHelper.IsApiProduct(product)) {
        gencodes.push(product.gencode);
      }
    });
    const params = {
      typeParcours: cart.getQuote().context.id,
      typeClient: cart.getCustomerCategory(),
      edp: !!quote.getProductsByType(Edp).length,
      gencodes,
      noPersonne: cart?.userId
    };
    if (quote.isRenewal()) {
      params.contractId = quote.context.contractId.toString();
    }
    const coupon = cart.promotions.coupon;
    if (coupon) {
      params.coupon = coupon.code;
    }
    const shipping = quote.address.shipping;
    if (shipping?.codePostal) {
      params.adresse = {
        codePostal: shipping.codePostal
      };
    }
    return params;
  }
  static IsApiProduct(product) {
    if (product instanceof Product) {
      product = product.gencode;
    }
    return !SalesApiHelper.InternalProductGencode.some(gencode => product === gencode);
  }
}
let GalliumService = /*#__PURE__*/(() => {
  class GalliumService {
    checkoutStorage;
    _storageKey = 'galliumPrices';
    _galliumDataKey = 'galliumData';
    constructor(checkoutStorage) {
      this.checkoutStorage = checkoutStorage;
    }
    getGalliumPrices(gencode) {
      const galliumPrices = this.checkoutStorage.get(this._storageKey, false);
      return galliumPrices && galliumPrices?.[gencode];
    }
    getGalliumData(gencode, contractId, isOwnedPlan) {
      const data = this.checkoutStorage.get(this._galliumDataKey, false);
      return isOwnedPlan ? data[contractId].opSource : data[contractId].simulation.find(s => s.idOffre === gencode);
    }
    renewalPriceUpdate(cart) {
      const plan = cart.getQuote().getProductByType(Plan);
      if (plan) {
        const galliumPrices = this.checkoutStorage.get(this._storageKey, false);
        const matchingGalliumPrice = galliumPrices && galliumPrices[plan?.data?.gencode];
        if (matchingGalliumPrice) {
          plan.data.price = plan.prices.base = plan.prices.final = matchingGalliumPrice.hasOwnProperty('promoPrice') ? matchingGalliumPrice.promoPrice : matchingGalliumPrice.price;
        }
      }
    }
    static ɵfac = function GalliumService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GalliumService)(i0.ɵɵinject(CheckoutStorageService));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GalliumService,
      factory: GalliumService.ɵfac,
      providedIn: 'root'
    });
  }
  return GalliumService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PromotionRepository = /*#__PURE__*/(() => {
  class PromotionRepository {
    oauth2Ressource;
    galliumService;
    userService;
    faiRepository;
    constructor(oauth2Ressource, galliumService, userService, faiRepository) {
      this.oauth2Ressource = oauth2Ressource;
      this.galliumService = galliumService;
      this.userService = userService;
      this.faiRepository = faiRepository;
    }
    deletePromotion(cart, id = cart.coupon) {
      if (!id) {
        return of(null);
      }
      return this.oauth2Ressource.useSalesApi().ventes().panier(cart.cartId).promotions(id).delete();
    }
    getCouponPromotionForCart(cart, code) {
      return this.getPromotionsForCart(cart, [code]).pipe(map(data => data.coupon || null));
    }
    getPromotionsForCart(cart, coupons = null) {
      // Don't Call if no quote or no product
      if (!cart.getQuote() || !cart.getAllProducts().length) {
        console.log('You need quote with product to get promotion');
        return of(new PromotionsModel([], [], [], null));
      }
      // same value use existing
      if (cart.promotions.coupon?.code && !coupons || cart.promotions.coupon?.code && coupons && cart.promotions.coupon.code === coupons[0]) {
        coupons = [cart.promotions.coupon.code];
      }
      return this.getPromotions(cart, this._getCartGencodes(cart), coupons).pipe(map(promotions => {
        // handle coupon changes
        if (cart.promotions.coupon && !promotions.coupon?.equal(cart.promotions.coupon)) {
          cart.promotions.setCoupon(promotions.coupon);
        }
        return promotions;
      }));
    }
    getPromotions(cart, gencodes, coupons = null, rio = null) {
      return this.getEligibilityPromoFromApi(cart, gencodes, coupons, rio).pipe(map(promos => {
        return new PromotionsModel([].concat(promos.automatic, promos.incitation.filter(p => this._mustBeAutomatic(p, cart))), [].concat(promos.manual), [].concat(promos.incitation), promos.coupon);
      }), catchError(err => {
        console.log(err);
        return of(new PromotionsModel([], [], [], null));
      }));
    }
    getEligibilityPromoFromApi(cart, gencodes, coupons = null, rio = null) {
      const payload = this.getEligibilityPromoPayload(cart, gencodes, rio);
      if (coupons?.length > 0) {
        payload.panier.coupons = coupons;
      }
      return this.oauth2Ressource.ventes().panier().eligibilitePromotionnelle().useSalesApi().addCache().post(payload).pipe(map(data => {
        const promotionsModel = data?.map(el => this._getPromotions(el));
        return this._getMergedPromotion(promotionsModel);
      }), catchError(error => {
        return throwError(() => new Error(error));
      }));
    }
    getEligibilityPromoPayload(cart, gencodes = {}, rio = null) {
      const payload = {
        typeClient: cart.isPro ? CUSTOMER_CATEGORY.PRO : CUSTOMER_CATEGORY.GP,
        panier: {
          promotionsManuelles: [],
          parcours: this._getQuote(cart)
        },
        produits: this._getPromoProducts(gencodes, rio)
      };
      if (this.userService.user.id) {
        payload.idPU = +this.userService.user.id;
      }
      if (cart.getQuote().getProductByType('Edp')) {
        payload.panier.modeDeFinancement = FUNDING_ENUM.MULTI_PRODUCT;
      }
      if (cart.getQuote().context?.contractId) {
        payload.idContract = +cart.getQuote().context?.contractId;
      }
      return payload;
    }
    _getPromotions(data) {
      const arrayPromotionsModel = data.parcours.map(p => p.produits?.reduce((acc, product) => {
        const promoModel = new PromotionsModel(this._mergePromotions(acc.automatic, product.promotions.automatiques.map(promo => this._getPromotionsModel(promo, [product.gencode]))), this._mergePromotions(acc.manual, product.promotions.manuelles.map(promo => this._getPromotionsModel(promo, [product.gencode]))), this._mergePromotions(acc.incitation, product.promotions.incitations.map(promo => this._getPromotionsModel(promo, [product.gencode]))));
        // On exclu les noeud 'avecLeProduit' qui ne sont pas utiles pour les coupons
        if (!data.avecLeProduit) {
          const coupons = product.promotions.coupons || [];
          const couponsUniques = product.promotions.couponsUniques || [];
          const allCoupons = coupons.concat(couponsUniques);
          if (allCoupons.length > 0) {
            promoModel.coupon = this._mergeCouponPromotion(acc.coupon, this._getPromotionsModel(allCoupons[0], [product.gencode]));
          } else {
            promoModel.coupon = acc.coupon;
          }
        }
        return promoModel;
      }, new PromotionsModel([], [], [], null)));
      return arrayPromotionsModel.reduce((previous, current) => {
        return new PromotionsModel(this._mergePromotions(previous.automatic, current.automatic), this._mergePromotions(previous.manual, current.manual), this._mergePromotions(previous.incitation, current.incitation), this._mergeCouponPromotion(previous.coupon, current.coupon));
      }, new PromotionsModel([], [], [], null));
    }
    _mergeCouponPromotion(currentCoupon, couponToMerge) {
      if (!currentCoupon?.code && couponToMerge != null) {
        return couponToMerge;
      }
      couponToMerge?.relevantProducts?.forEach(rp => {
        if (!currentCoupon.relevantProducts.includes(rp)) {
          currentCoupon.relevantProducts.push(rp);
        }
      });
      return currentCoupon;
    }
    _getPromotionsModel(data, products) {
      return new PromotionModel({
        id: data.id,
        addProduct: data.produitAAjouter,
        name: data.nom,
        label: data.libelle,
        type: data.type,
        description: data.description,
        amount: +data.valeurRemise,
        reductionType: data.typeRemise === 'POURCENTAGE' ? REDUCTION_TYPE.POURCENT : REDUCTION_TYPE.FIX,
        reductionAmount: data.valeurRemiseReelle,
        duration: data.duree,
        dates: data.dates,
        code: data.type === API_PROMO_TYPE.COUPON || data.type === API_PROMO_TYPE.CPU ? data.coupon : null,
        message: {
          ...data.message,
          ...{
            portability_other: data.proprietesSupplementaires?.blocPorta
          }
        },
        relevantProducts: products,
        typesMarketing: this._getTypesMarketingArray(data.proprietesSupplementaires?.typesMarketing),
        fanion: data.proprietesSupplementaires?.fanion,
        accessTypes: data.typesAcces || []
      });
    }
    _getQuote(cart) {
      return cart.quotes.map((quote, indexQuote) => ({
        type: quote.context.id,
        idVirtuel: indexQuote,
        promotionsManuelles: [],
        produits: this._getProduct(quote)
      }));
    }
    _getPromoProducts(quotesGencodes, rio = null) {
      return Object.keys(quotesGencodes).map(gencode => ({
        promotionsManuelles: [],
        ajouterDansLeParcours: quotesGencodes[gencode],
        gencode,
        codePostalFaiInstallation: this.faiRepository.getEligibility()?.resultat?.codePostal ?? null,
        rio
      }));
    }
    _getProduct(quote) {
      return quote.products.filter(p => SalesApiHelper.IsApiProduct(p)).map((product, indexProduct) => ({
        promotionsManuelles: product.promotions.manual.map(p => p.id),
        gencode: product.gencode,
        idVirtuel: indexProduct,
        rio: this._setRioForProduct(quote),
        codePostalFaiInstallation: this.faiRepository.getEligibility()?.resultat?.codePostal,
        // Temporary method - When get fundingMode ready use it
        modeDeFinancement: ProductFactory.Is(product, Phone) && quote.getProductByType('Edp') ? FUNDING_ENUM.EDP : null
      }));
    }
    _setRioForProduct(quote) {
      if (quote.forms?.portability?.active) {
        return quote.forms?.portability?.codeRio || null;
      }
      return null;
    }
    _mergePromotions(promotionsA, promotionsB) {
      for (const promoB of promotionsB) {
        const promoA = promotionsA.find(p => p.id === promoB.id && p.reductionAmount === promoB.reductionAmount);
        if (!promoA) {
          promotionsA.push(promoB);
        }
        if (promoA) {
          promoA.relevantProducts = [...new Set([...promoA.relevantProducts, ...promoB.relevantProducts])];
        }
      }
      return promotionsA;
    }
    /**
     * Merge promotions model
     * @param promos promotions model array
     * @returns PromotionsModel
     */
    _getMergedPromotion(promos) {
      return promos?.reduce((acc, value) => new PromotionsModel(this._mergePromotions(acc.automatic, value.automatic), this._mergePromotions(acc.manual, value.manual), this._mergePromotions(acc.incitation, value.incitation), this._mergeCouponPromotion(acc.coupon, value.coupon)));
    }
    _getTypesMarketingArray(types) {
      if (!types) {
        return [];
      }
      return types;
    }
    /**
     * Get current cart gencodes for eligibilty promo
     * @param cart Current cart
     * @returns List of gencodes
     */
    _getCartGencodes(cart) {
      const quote = cart.getQuote();
      const isRenewal = quote.isRenewal();
      if (isRenewal) {
        this.galliumService.renewalPriceUpdate(cart);
      }
      let cartProducts = {};
      cart.quotes.forEach((quoteModel, index) => {
        const products = this._filterCartProducts(quoteModel.products, isRenewal);
        products.forEach(product => product.crossSells.forEach(crossSell => cartProducts[crossSell] = index));
      });
      return cartProducts;
    }
    _filterCartProducts(products, isRenewal) {
      return products.filter(product => SalesApiHelper.IsCompatibleWithPromotions(product) && SalesApiHelper.IsApiProduct(product)
      // Ne pas inclure les forfaits mobiles => SIM en crossell
      && !ProductFactory.Is(product, 'Sowo') && !ProductFactory.Is(product, 'Sensation') && (!isRenewal || !ProductFactory.Is(product, 'Plan')));
    }
    _mustBeAutomatic(promo, cart) {
      return cart.quotes.some(quote => {
        const plan = quote.getProductByType(Plan);
        return promo.relevantProducts.includes(plan?.gencode) && plan?.portability?.active && !quote.forms?.portability?.codeRio && promo.accessTypes.includes(ACCESS_TYPE.PORTABILITE);
      });
    }
    static ɵfac = function PromotionRepository_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PromotionRepository)(i0.ɵɵinject(Oauth2ResourcesService), i0.ɵɵinject(GalliumService), i0.ɵɵinject(UserService), i0.ɵɵinject(FaiRepository));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: PromotionRepository,
      factory: PromotionRepository.ɵfac,
      providedIn: 'root'
    });
  }
  return PromotionRepository;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// @dynamic
let ReferrerService = /*#__PURE__*/(() => {
  class ReferrerService {
    document;
    constructor(document) {
      this.document = document;
    }
    /**
     * Check referrer validity into domain
     * @param referrers referrers list
     * @returns boolean
     */
    isReferrerValid(referrers) {
      const domain = this._getReferrerDomain();
      if (referrers && !domain || referrers && domain && !referrers.some(r => domain.includes(r))) {
        return false;
      }
      return true;
    }
    /**
     * Extract domain from referrer
     * @param referrer referrer
     * @returns string
     */
    _getReferrerDomain() {
      const url = this.document.referrer ? new URL(this.document.referrer) : null;
      return url?.hostname || null;
    }
    static ɵfac = function ReferrerService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ReferrerService)(i0.ɵɵinject(DOCUMENT));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ReferrerService,
      factory: ReferrerService.ɵfac,
      providedIn: 'root'
    });
  }
  return ReferrerService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FundingService = /*#__PURE__*/(() => {
  class FundingService {
    fundingMethods;
    static younited_key = 'funding_selected';
    userService = inject(UserService);
    storageService = inject(CheckoutStorageService);
    fundingRepository = inject(FundingRepository);
    constructor() {
      this.storageService.addLocalKey({
        [FundingService.younited_key]: [STORAGE_TAGS.ORDER]
      });
    }
    getLastFundingMethodsForCart() {
      return this.fundingMethods;
    }
    getCurrentFundingMethod(cartId) {
      return this.fundingRepository.getCurrentFundingMethod(cartId);
    }
    getFundingModes(cartModel) {
      return this.fundingRepository.getFundingCart(cartModel.cartId).pipe(tap(fundingCart => {
        this.fundingMethods = fundingCart.fundingMethods;
      }));
    }
    getVirtualFundingModes(cartModel) {
      return this.fundingRepository.getVirtualCartFundingModes(cartModel, +this.userService.user.id);
    }
    getYounitedSelectedProposal(funding) {
      if (!funding || funding.type !== FUNDING_ENUM.YOUNITED && funding.type !== FUNDING_ENUM.SWAPPY) return null;
      const proposals = funding.commercialProposal;
      let proposalChoiced;
      let defaultYounitedValue = proposals[0];
      const twoYearsFunding = proposals.find(cp => cp.nbLoan === 24);
      const younitedChoice = this.getCreditChoice();
      if (younitedChoice) {
        proposalChoiced = proposals.find(cp => cp.nbLoan === this.getCreditChoice());
      }
      if (proposalChoiced) {
        defaultYounitedValue = proposalChoiced;
      } else if (twoYearsFunding) {
        defaultYounitedValue = twoYearsFunding;
      }
      return defaultYounitedValue;
    }
    getCofidisSelectedProposal(funding) {
      if (!funding || funding.type !== FUNDING_ENUM.COFIDIS) return null;
      const proposals = funding.commercialProposal;
      let proposalChoiced;
      let defaultCofidisValue = proposals[0];
      const defautFunding = proposals.find(cp => cp.nbLoan === 2);
      const choice = this.getCreditChoice();
      if (choice) {
        proposalChoiced = proposals.find(cp => cp.nbLoan === this.getCreditChoice());
      }
      if (proposalChoiced) {
        defaultCofidisValue = proposalChoiced;
      } else if (defautFunding) {
        defaultCofidisValue = defautFunding;
      }
      return defaultCofidisValue;
    }
    getCreditChoice() {
      return this.storageService.get(FundingService.younited_key);
    }
    saveCreditChoice(nbLoan) {
      this.storageService.set(FundingService.younited_key, nbLoan);
    }
    getSelectedProposalByMethod(funding) {
      switch (funding?.type) {
        case FUNDING_ENUM.YOUNITED:
        case FUNDING_ENUM.SWAPPY:
          return this.getYounitedSelectedProposal(funding);
        case FUNDING_ENUM.COFIDIS:
          return this.getCofidisSelectedProposal(funding);
        default:
          return null;
      }
    }
    static ɵfac = function FundingService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FundingService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FundingService,
      factory: FundingService.ɵfac,
      providedIn: 'root'
    });
  }
  return FundingService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const SKELETON_PAGE_CLASS = 'skeleton-page';
const IS_LOADING_CLASS = 'is-loading';
// eslint-disable-next-line max-len
const EMAIL_REGEXP = RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, 'i'); // NOSONAR
const NAME_REGEXP = /^(?!\s)[a-zA-Z-'` ÀÂÄÇÈÉÊËÎÏÔÖÙÛÜàáâäçèéêëîïôöùûü]+(\S+)$/;
const MOBILE_REGEXP = new RegExp(/^(06|07)([0-9]{8})$/);
const PHONE_REGEXP = new RegExp(/^0[1-9]([0-9]{8})$/);
const DATE_REGEXP = RegExp('(0[1-9]|[12][0-9]|3[01])[/](0[1-9]|1[012])[/](19|20)[0-9][0-9]$');
const FAI_REGEX = new RegExp(/^0[123459]{1}[0-9]{8}$/); // NOSONAR
const FRENCH_SIMPLE_DATE_REGEXP = RegExp('(0[1-9]|[12][0-9]|3[01])[/](0[1-9]|1[012])[/](19|20)[0-9][0-9]$');
const ALPHA_NUM_REGEXP = RegExp(/^[a-zA-Z0-9]*$/);
const NUMBERS_REGEXP = RegExp(/^[0-9]*$/);
const POSTAL_ADDRESS_REGEXP = RegExp(/^[a-zA-Z0-9 '` ÀÂÄÇÈÉÊËÎÏÔÖÙÛÜàáâäçèéêëîïôöùûü-]*$/);
const ZIP_CODE_REGEXP = /^[0-9]{5}$/;
const SIREN_REGEXP = /^[0-9]{9}$/;
const EMAIL_BBOX_REGEXP = /^\w+([-+.']\w+)*@?(bbox.fr)$/; // NOSONAR
const NOT_EMAIL_BBOX_REGEXP = /^\w+[-\.\w]*@(?!(?:bbox)\.fr$)\w+[-\.\w]*?\.\w{2,}$/; // NOSONAR
const VOIP_REGEXP = new RegExp(/^(09)([0-9]{8})$/);
// PWD ALLOWED characters are code ASCII Hexa 21 to 7E
const PWD_SPECIAL_CHARACTERS = '!"#$%&\'()+,-./:;<=>?@^_`{}|~*\\]\\[\\\\';
const SPECIAL_CHARACTERS = new RegExp(`[${PWD_SPECIAL_CHARACTERS}]`); // NOSONAR
const REJECTED_CHAR_REGEX = new RegExp(`(?![\\w${PWD_SPECIAL_CHARACTERS}]).+`); // NOSONAR
const PWD_RULES = {
  MAX_LENGTH: 20,
  MIN_LENGTH: 8,
  ALPHA_FOLLOW_MAX: 6,
  NUM_FOLLOW_MAX: 6,
  UPPERCASE: /[A-Z]/,
  LOWERCASE: /[a-z]/,
  DIGIT: /[0-9]/,
  SPECIAL_CHARACTERS,
  REJECTED_CHAR_REGEX
};
const REGEXS = {
  EMAIL_REGEXP,
  NAME_REGEXP,
  MOBILE_REGEXP,
  PHONE_REGEXP,
  DATE_REGEXP,
  FAI_REGEX,
  ALPHA_NUM_REGEXP,
  NUMBERS_REGEXP,
  FRENCH_SIMPLE_DATE_REGEXP,
  POSTAL_ADDRESS_REGEXP,
  ZIP_CODE_REGEXP,
  SIREN_REGEXP,
  EMAIL_BBOX_REGEXP,
  NOT_EMAIL_BBOX_REGEXP,
  VOIP_REGEXP
};
const PARENTAL_CONTROL_PREMIUM = ['12965', '72154083'];
const PARENTAL_CONTROL_FREE = ['11148', '72150789'];
var SHIPPING_MODES = /*#__PURE__*/function (SHIPPING_MODES) {
  SHIPPING_MODES["CLICK_AND_COLLECT"] = "CLICK_COLLECT";
  SHIPPING_MODES["RELAIS_EXPRESS"] = "POINT_RELAIS_EXPRESS";
  SHIPPING_MODES["RELAIS_COLIS"] = "POINT_RELAIS";
  SHIPPING_MODES["LA_POSTE"] = "LA_POSTE";
  SHIPPING_MODES["CHRONOPOST"] = "CHRONOPOST";
  SHIPPING_MODES["INSTALLER"] = "INSTALLATEUR";
  SHIPPING_MODES["DIRECT"] = "LIVRAISON_DIRECTE";
  SHIPPING_MODES["LIVRAISON_RDV"] = "LIVRAISON_RDV";
  return SHIPPING_MODES;
}(SHIPPING_MODES || {});
const OPTION_LOCKED_ID = '12782';
var OFFER_CATEGORY_CODE = /*#__PURE__*/function (OFFER_CATEGORY_CODE) {
  OFFER_CATEGORY_CODE["FAI_SIMO"] = "FAI-SIMO";
  OFFER_CATEGORY_CODE["FAI_BYOU"] = "fai-byou";
  OFFER_CATEGORY_CODE["BELOW_THE_LINE_WEB"] = "below_the_line_web";
  return OFFER_CATEGORY_CODE;
}(OFFER_CATEGORY_CODE || {});
let DeliveryService = /*#__PURE__*/(() => {
  class DeliveryService {
    setDelivery(cartService, cartModel, deliveryInfo, quoteIndex = cartModel.currentQuoteIndex) {
      const deliveryProduct = new Delivery(Delivery.prefillData({
        libelle: deliveryInfo.libelle,
        prix: deliveryInfo.prix,
        gencode: deliveryInfo.gencode,
        typePrix: deliveryInfo.typePrix
      }));
      return cartService.addProduct(cartModel, deliveryProduct, quoteIndex).pipe(finalize(() => this._save(cartService, cartModel, deliveryInfo, quoteIndex)));
    }
    getDelivery(cartService, cartModel, quoteIndex = cartModel.currentQuoteIndex) {
      const deliveryInfo = cartModel.getQuote(quoteIndex).forms?.deliveryInfo;
      return deliveryInfo ? new DeliveryInfo(deliveryInfo) : null;
    }
    removeDelivery(cart, cartModel, product, quoteIndex) {
      if (!ProductFactory.Is(product, Delivery) && !ProductFactory.Is(product, Edp)) {
        const quote = cartModel.getQuote(quoteIndex);
        const deliveryProduct = quote.getProductByType(Delivery);
        if (deliveryProduct) {
          if (cartModel.getQuote(quoteIndex).forms?.deliveryInfo) {
            delete cartModel.getQuote(quoteIndex).forms.deliveryInfo;
          }
          return cart.removeProduct(cartModel, deliveryProduct, quoteIndex, false);
        }
      }
      return of(product);
    }
    _save(cartService, cartModel, deliveryInfo, quoteIndex = cartModel.currentQuoteIndex) {
      cartModel.getQuote(quoteIndex).addFormData({
        deliveryInfo
      });
      cartService.save(cartModel);
    }
    static ɵfac = function DeliveryService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DeliveryService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: DeliveryService,
      factory: DeliveryService.ɵfac,
      providedIn: 'root'
    });
  }
  return DeliveryService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// @dynamic
let PartnersService = /*#__PURE__*/(() => {
  class PartnersService extends ReferrerService {
    configService;
    constructor(configService) {
      super(document);
      this.configService = configService;
    }
    /**
     * Check if partner offer is valid
     * @param urlKeys url key attribut
     * @returns null if valid or partnerOffers name for error modal
     */
    isPartnerOfferValid(urlKeys) {
      const partnerOffers = this.configService.getData().partner?.offers || {};
      const partnerUrl = partnerOffers ? urlKeys.find(url => partnerOffers[url]) : null;
      const referrers = partnerUrl ? partnerOffers[partnerUrl]?.referrer : null;
      return this.isReferrerValid(referrers) ? null : partnerOffers[partnerUrl];
    }
    checkProductReferrer(product) {
      this._checkYamaReferrer(product);
    }
    _checkYamaReferrer(product) {
      const yamaReferrers = this.configService.getData().yama?.referrers || [];
      if (product.data.banking_offer === true && !this.isReferrerValid(yamaReferrers)) {
        throw new PartnerError('OMB exclusive offer');
      }
    }
    static ɵfac = function PartnersService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PartnersService)(i0.ɵɵinject(ConfigurationService));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: PartnersService,
      factory: PartnersService.ɵfac,
      providedIn: 'root'
    });
  }
  return PartnersService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ScoringService = /*#__PURE__*/(() => {
  class ScoringService {
    checkoutStorage;
    oauthService;
    static INCOMPATIBLE_RULES = {
      'global.ligneMarcheFnb.voixSansEngagement': ['Sowo'],
      'global.ligneMarcheFnb.voixAvecEngagement': ['Simo', 'Sensation'],
      'global.ligneMarcheFnb.forfaitData': ['Faim', 'FaimUnlimited', 'FaimPremium'],
      'global.ligneMarcheFai.fai': ['Fai']
    };
    static EDP_GLOBAL = 'global.edp';
    // Si le client met au panier un produit (terminal / galet) éligible à l'étalement de paiement
    // alors que global.edp présente un message ==>
    // Alors ne pas proposer l'EDPdnas les choix de mode de paiement
    _storageScoringKey = 'scoring';
    constructor(checkoutStorage, oauthService) {
      this.checkoutStorage = checkoutStorage;
      this.oauthService = oauthService;
    }
    deleteScoring() {
      this.checkoutStorage.remove(this._storageScoringKey);
    }
    getScoringFromStorage(path, withoutMessage = false) {
      const scoring = this.checkoutStorage.get(this._storageScoringKey);
      return this._get(scoring, `${path}${withoutMessage ? '' : '.message'}`);
    }
    saveScoring(data) {
      this.checkoutStorage.set(this._storageScoringKey, data, true, addDays(new Date(), 1).getTime());
    }
    checkScoring(quoteItem) {
      if (this.oauthService.isConnected) {
        const matchingRule = Object.keys(ScoringService.INCOMPATIBLE_RULES).find(rule => !!ScoringService.INCOMPATIBLE_RULES[rule].find(product => ProductFactory.Is(quoteItem, product, true)));
        const incompatibleScoringFromStorage = this.getScoringFromStorage(matchingRule);
        if (incompatibleScoringFromStorage) {
          throw new Error(incompatibleScoringFromStorage);
        }
      } else {
        this.deleteScoring();
      }
    }
    isEDPIncompatible() {
      return !!this.getScoringFromStorage(ScoringService.EDP_GLOBAL, true);
    }
    _get(data, path) {
      const pathArray = path.split('.');
      let currentData = data;
      pathArray.forEach(key => {
        currentData = currentData && currentData[key];
      });
      return currentData;
    }
    static ɵfac = function ScoringService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ScoringService)(i0.ɵɵinject(CheckoutStorageService), i0.ɵɵinject(Oauth2Service));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ScoringService,
      factory: ScoringService.ɵfac,
      providedIn: 'root'
    });
  }
  return ScoringService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const YAMA_STORAGE_KEY = 'yama_cart';
// @dynamic
let CartCheckoutService = /*#__PURE__*/(() => {
  class CartCheckoutService extends CartService {
    promotionRepo;
    productRepo;
    cartQuoteSubscription = new ReplaySubject(1);
    cartRefreshObs;
    productActionObs;
    paymentMethodObs;
    cartLoadedFromStorageObs;
    couponActionObs;
    cartModelObs;
    _cartRefreshSubject = new BehaviorSubject(this);
    cartModelSubject = new BehaviorSubject(null);
    _productActionSubject = new Subject();
    _paymentMethodSubject = new Subject();
    _cartLoadedFromStorage = new Subject();
    _couponActionSubject = new Subject();
    oauth2Resource = inject(CheckoutOauth2ResourcesService);
    checkoutStorage = inject(CheckoutStorageService);
    userService = inject(UserService);
    oauth2Service = inject(Oauth2Service);
    deliveryService = inject(DeliveryService);
    scoringService = inject(ScoringService);
    partnersService = inject(PartnersService);
    fundingService = inject(FundingService);
    document = inject(DOCUMENT);
    cartRepository = inject(CartRepository);
    quoteContextFactory = inject(QuoteContextFactory);
    currentStepKey = 'current_step';
    useVirtualFundingStepKeysList = ['cart', 'summary'];
    constructor(
    // NOSONAR
    promotionRepo, productRepo) {
      super(promotionRepo, productRepo);
      this.promotionRepo = promotionRepo;
      this.productRepo = productRepo;
      this.cartModelObs = this.cartModelSubject.asObservable();
      this.cartRefreshObs = this._cartRefreshSubject.asObservable();
      this.productActionObs = this._productActionSubject.asObservable();
      this.paymentMethodObs = this._paymentMethodSubject.asObservable();
      this.cartLoadedFromStorageObs = this._cartLoadedFromStorage.asObservable();
      this.couponActionObs = this._couponActionSubject.asObservable();
    }
    addProduct(cartModel, product, quoteIndex = cartModel.currentQuoteIndex, autoRefresh = true) {
      try {
        // Do not check referrer when renew
        if (!cartModel.getQuote(quoteIndex)?.isRenewal() && cartModel.type !== CART_TYPES.BANK) {
          this.partnersService.checkProductReferrer(product);
        }
        this._checkStock(product);
        this.scoringService.checkScoring(product);
        return super.addProduct(cartModel, product, quoteIndex, false).pipe(mergeMap(() => this.deliveryService.removeDelivery(this, cartModel, product, quoteIndex)), mergeMap(() => autoRefresh ? this._checkCoupon(cartModel) : of(null)), tap(() => this._cleanForms(cartModel, product, quoteIndex)), mergeMap(() => autoRefresh ? from(this.refresh(cartModel, quoteIndex)) : of(null)), mergeMap(() => autoRefresh ? this.updateFunding(cartModel) : of(null)), tap(() => this._productActionSubject.next({
          product,
          quote: cartModel.quotes[quoteIndex],
          action: UPDATE_ACTIONS.ADD
        })), tap(() => this.updateHeaderProductCounter(product, cartModel)), map(() => product));
      } catch (err) {
        if (err.errorThrown) {
          return of(null);
        }
        console.error(err.message, product);
        return throwError(err);
      }
    }
    updateHeaderProductCounter(product, cartModel) {
      if (product && (product.isPrincipal || ProductFactory.Is(product, Accessory))) {
        let counter = 0;
        cartModel.quotes.forEach(quote => {
          counter += quote.products.filter(quoteProduct => quoteProduct.isPrincipal || ProductFactory.Is(quoteProduct, Accessory)).length;
        });
        window.postMessage({
          panier: {
            badge: counter
          }
        }, window.location.origin);
      }
    }
    removeProduct(cartModel, product, quoteIndex = cartModel.currentQuoteIndex, autoRefresh = false) {
      return super.removeProduct(cartModel, product, quoteIndex, autoRefresh).pipe(tap(() => this._productActionSubject.next({
        product,
        quote: cartModel.quotes[quoteIndex],
        action: UPDATE_ACTIONS.REMOVE
      })), mergeMap(() => this.deliveryService.removeDelivery(this, cartModel, product, quoteIndex)), tap(() => this._cleanForms(cartModel, product, quoteIndex)), mergeMap(() => autoRefresh ? from(this.refresh(cartModel, quoteIndex)) : of(null)), mergeMap(() => autoRefresh ? this.updateFunding(cartModel) : of(null)), mergeMap(() => autoRefresh ? this._checkCoupon(cartModel) : of(null)), tap(() => this.updateHeaderProductCounter(product, cartModel)), map(() => product));
    }
    removeProductsByGencode(cartModel, gencode, quoteIndex = 0) {
      const quote = cartModel.quotes[quoteIndex];
      const removeObs = [];
      let removedProducts = [];
      quote.getProductsByGencode(gencode).forEach(product => {
        removeObs.push(this.removeProduct(cartModel, product, quoteIndex, false));
      });
      return forkJoin(removeObs).pipe(mergeMap(products => {
        removedProducts = products;
        return this._checkCoupon(cartModel);
      }), mergeMap(() => from(this.refresh(cartModel, quoteIndex))), mergeMap(() => this.updateFunding(cartModel)), map(() => removedProducts));
    }
    addProductByGencode(cartModel, gencode, quoteIndex = 0, autoRefresh = true) {
      return this.productRepo.getProductByGencode(gencode).pipe(mergeMap(product => this.addProduct(cartModel, product, quoteIndex, autoRefresh)));
    }
    addProductsByAttributes(cartModel, values, attribute, quoteIndex = 0) {
      return this.productRepo.getProductsByAttributes(values, attribute).pipe(mergeMap(products => this.addProducts(cartModel, products, quoteIndex)));
    }
    addProductsByGencodes(cartModel, gencodes, quoteIndex = 0) {
      return this.productRepo.getProductsByGencodes(gencodes).pipe(mergeMap(products => this.addProducts(cartModel, products, quoteIndex)));
    }
    setPro(cartModel, isPro = true) {
      cartModel.isPro = !!isPro;
    }
    setIsFromProWall(cartModel, isProWall) {
      cartModel.isComingFromProWall = isProWall;
    }
    save(cartModel) {
      this.cartRepository.saveCart(cartModel);
      this.cartModelSubject?.next(cartModel);
    }
    updateProductQty(cartModel, product, qty, quoteIndex = cartModel.currentQuoteIndex) {
      const obs = [];
      const quote = cartModel.quotes[quoteIndex];
      const quoteProducts = quote.getProductsByGencode(product.gencode);
      const qtyInQuote = quoteProducts.length;
      const qtyDiff = qty - qtyInQuote;
      if (qtyDiff > 0) {
        for (let i = 0; i < Math.abs(qtyDiff); i++) {
          const newProduct = ProductFactory.GetInstance(product.data);
          obs.push(this.addProduct(cartModel, newProduct, quoteIndex, false));
        }
      } else if (qtyDiff < 0) {
        for (let i = 0; i < Math.abs(qtyDiff); i++) {
          obs.push(this.removeProduct(cartModel, quoteProducts[i], quoteIndex, false));
        }
      }
      let productsAdded = [];
      return forkJoin(obs.map(observable => observable.pipe(catchError(error => of({
        withError: true,
        error
      }))))).pipe(tap(res => {
        productsAdded = res.filter(value => ProductFactory.Is(value, 'Product'));
      }), mergeMap(() => this._checkCoupon(cartModel)), mergeMap(() => from(this.refresh(cartModel, quoteIndex))), mergeMap(() => this.updateFunding(cartModel)), map(() => productsAdded));
    }
    removeQuote(cartModel, quoteIndex = cartModel.currentQuoteIndex) {
      const quoteToRemove = cartModel.getQuote(quoteIndex);
      if (quoteToRemove?.id) {
        return this.deleteQuote(cartModel.cartId, quoteToRemove.id).pipe(mergeMap(() => super.removeQuote(cartModel, quoteIndex)), tap(() => this.cartQuoteSubscription.next(quoteIndex)));
      } else {
        return super.removeQuote(cartModel, quoteIndex).pipe(tap(() => this.cartQuoteSubscription.next(quoteIndex)));
      }
    }
    async removeQuoteProducts(cartModel, quote, quoteIndex) {
      const removePromises = [];
      quote.products.forEach(product => {
        removePromises.push(lastValueFrom(this.removeProduct(cartModel, product, quoteIndex, false)));
      });
      await Promise.all(removePromises);
      await lastValueFrom(this._checkCoupon(cartModel));
      await this.refresh(cartModel, quoteIndex);
      await this.updateFunding(cartModel, quoteIndex);
    }
    async initCart(cartModel) {
      if (!this.cartRepository.initCartFromStorage(cartModel)) {
        this.addQuote(cartModel);
      }
      if (!this.document.location.href.includes('tunnel/redirect')) {
        const isCartValid = await this._checkCartValidity(cartModel);
        if (isCartValid) {
          this.refreshType(cartModel);
          await this.refresh(cartModel, cartModel.currentQuoteIndex);
        } else {
          this.clear(cartModel);
          this.addQuote(cartModel);
        }
      }
      this._cartLoadedFromStorage.next(null);
      return this;
    }
    async resolve(cartModel) {
      cartModel.userId = this.userService.user.id;
      await this.refresh(cartModel, cartModel.currentQuoteIndex);
    }
    resetAll(tag = null) {
      if (tag) {
        this.checkoutStorage.clearTag(tag);
      } else {
        this.checkoutStorage.clearTag(STORAGE_TAGS.ORDER);
        this.checkoutStorage.clearTag(STORAGE_TAGS.CUSTOMER);
        this.checkoutStorage.clearTag(STORAGE_TAGS.ELIGIBILITY);
      }
    }
    refresh(cartModel, quoteIndex = cartModel.currentQuoteIndex) {
      return super.refresh(cartModel).then(() => lastValueFrom(of(true).pipe(catchError(() => of(null)), tap(() => {
        this.refreshCartIsPro(cartModel);
        this.save(cartModel);
        this._cartRefreshSubject.next(this);
        this.cartQuoteSubscription.next(quoteIndex);
      }), map(() => null))));
    }
    setFundingMethod(cartModel, fundingMethod) {
      cartModel.fundingMethod = fundingMethod;
      this.save(cartModel);
      this._paymentMethodSubject.next(null);
      return of(true);
    }
    addProducts(cartModel, products, quoteIndex = 0) {
      products.sort((product, product2) => Math.sign(this._getProductSortOrder(product) - this._getProductSortOrder(product2)));
      const removeObs = this.removeAutoAddProductObs(cartModel, products, quoteIndex);
      const addObs = products.map(product => this.addProduct(cartModel, product, quoteIndex, false));
      return from(removeObs.length > 0 ? removeObs : of(null)).pipe(concatAll(), last(), catchError(() => of(null)), concatMap(() => from(addObs).pipe(concatAll(), last())), mergeMap(() => from(this.refresh(cartModel, quoteIndex))), mergeMap(() => this.updateFunding(cartModel)), mergeMap(() => of(products)));
    }
    addProductsToCart(gencodes, cartModel, isFai, contractId = null) {
      const isMixedCart = cartModel.isMixed();
      return this.productRepo.getProductsByGencodes(gencodes).pipe(mergeMap(productsToAdd => {
        const onlyAccessoriesOrOptionsAdded = productsToAdd.every(product => ProductFactory.Is(product, Accessory) || ProductFactory.Is(product, Option));
        // Reset cart if it's a banking cart
        if (cartModel.isBanking() && !cartModel.isCartEmpty() && !onlyAccessoriesOrOptionsAdded) {
          this.clear(cartModel);
          this.addQuote(cartModel);
          this.refreshType(cartModel);
          this.save(cartModel);
        }
        if (!!contractId) {
          return this.handleRenewContext(contractId, cartModel, productsToAdd, onlyAccessoriesOrOptionsAdded);
        }
        const quotes = [cartModel.getQuote(0), cartModel.getQuote(1)];
        const newQuoteContextModel = isFai ? QuoteContextFaiModel : QuoteContextAcquisitionModel;
        // Case Auto-add FAI when quotes aren't created yet
        if (isFai && !quotes[0]) {
          return this._handleAddToCartWithAutoAdd(cartModel, productsToAdd);
        }
        const productToAddPMCompatible = this._isProductToAddPMCompatible(cartModel, productsToAdd, isFai);
        if (isMixedCart) {
          return this._handleAddToMixedCart(onlyAccessoriesOrOptionsAdded, cartModel, productsToAdd, quotes, productToAddPMCompatible, newQuoteContextModel);
        }
        // ----------------------------- Cart Single quote -----------------------------
        return this._handleAddToNonMixedCart(onlyAccessoriesOrOptionsAdded, cartModel, productsToAdd, quotes, productToAddPMCompatible, newQuoteContextModel);
      }), mergeMap(() => this.getCart()));
    }
    getCart() {
      const newCartModel = new CheckoutCartModel();
      this.cartRepository.initCartFromStorage(newCartModel);
      return of(newCartModel);
    }
    async updateFunding(cartModel, quoteIndex = 0) {
      const funding = cartModel.fundingMethod;
      if ((funding?.type === FUNDING_ENUM.YOUNITED || funding?.type === FUNDING_ENUM.SWAPPY) && cartModel.getQuote(quoteIndex).products.length > 0) {
        let fundingCart;
        if (cartModel.cartId && !this.currentStepMustUseVirtualFunding()) {
          fundingCart = await lastValueFrom(this.fundingService.getFundingModes(cartModel));
        } else {
          fundingCart = await lastValueFrom(this.fundingService.getVirtualFundingModes(cartModel));
        }
        const updatedFunding = fundingCart?.fundingMethods.find(fundingMethod => fundingMethod.type === funding.type) ?? null;
        await lastValueFrom(this.setFundingMethod(cartModel, updatedFunding));
      }
      return Promise.resolve();
    }
    async updateVirtualFunding(cartModel) {
      return await lastValueFrom(this.fundingService.getVirtualFundingModes(cartModel));
    }
    currentStepMustUseVirtualFunding() {
      const currentStepKey = this.checkoutStorage.get(this.currentStepKey);
      return this.useVirtualFundingStepKeysList.includes(currentStepKey);
    }
    deleteCartIds(cart) {
      cart.cartId = null;
      cart.userId = null;
      cart.quotes.forEach(quote => {
        quote.id = null;
        quote.products.forEach(product => {
          product.id = null;
        });
        quote.address.billing = null;
        quote.address.shipping = null;
        delete quote.forms.deliveryInfo;
      });
      this.refresh(cart, cart.currentQuoteIndex);
      return this;
    }
    removeCouponPromotion(cart) {
      return super.removeCouponPromotion(cart).pipe(mergeMap(() => this.updateFunding(cart)), map(() => null), tap(() => {
        cart.coupon = null;
        this.save(cart);
        this._couponActionSubject.next();
      }));
    }
    setCouponPromotion(cart, promo) {
      return super.setCouponPromotion(cart, promo).pipe(mergeMap(() => this.updateFunding(cart)), map(() => null), tap(() => {
        this._couponActionSubject.next();
      }));
    }
    setQuoteContext(cartModel, contextType, params = {}, quoteIndex = 0) {
      const currentQuote = this.getQuote(cartModel, quoteIndex);
      const contextModel = new contextType();
      if (currentQuote?.context.id === contextModel.id) {
        return of(currentQuote.context);
      }
      return this.quoteContextFactory.createContext(contextType, params).pipe(tap(context => {
        this.refreshType(cartModel);
        this.addQuote(cartModel, context);
      }));
    }
    refreshCartIsPro(cartModel) {
      if (cartModel.isCartEmpty()) {
        this.setPro(cartModel, false);
        return;
      }
      const quote = cartModel.getQuote();
      const principalSubscription = quote.getPrincipalProduct('Plan');
      const isPro = this.userService.user?.isPro() || principalSubscription?.isPro || cartModel.isComingFromProWall;
      this.setPro(cartModel, !!isPro);
    }
    refreshType(cartModel) {
      const yamaCart = this.checkoutStorage.get(YAMA_STORAGE_KEY, false);
      cartModel.type = yamaCart ? CART_TYPES.BANK : CART_TYPES.WEB;
    }
    removeCoupon(cartModel) {
      return this.promotionRepo.deletePromotion(cartModel);
    }
    async getProductByGencode(gencode) {
      return await lastValueFrom(this.productRepo.getProductByGencode(gencode));
    }
    _checkStock(product) {
      if (!product.isInStock()) {
        throw new Error('Produit hors stock');
      }
    }
    _getProductSortOrder(product) {
      const orderToAdd = [Plan, Phone];
      const indexOrder = orderToAdd.findIndex(orderClass => ProductFactory.Is(product, orderClass));
      return indexOrder === -1 ? Infinity : indexOrder;
    }
    _checkCoupon(cartModel) {
      const coupon = cartModel.promotions.coupon;
      if (coupon) {
        return this.promotionRepo.getCouponPromotionForCart(cartModel, coupon.code).pipe(mergeMap(newCoupon => {
          cartModel.promotions.setCoupon(newCoupon);
          if (!newCoupon) {
            return this.removeCouponPromotion(cartModel);
          }
          return of(null);
        }), catchError(() => this.promotionRepo.deletePromotion(cartModel).pipe(mergeMap(() => this.removeCouponPromotion(cartModel)))), map(() => null));
      }
      return of(null);
    }
    _cleanForms(cartModel, product, quoteIndex = cartModel.currentQuoteIndex) {
      if (ProductFactory.Is(product, Plan)) {
        const quote = cartModel.getQuote(quoteIndex);
        delete quote?.forms?.portability;
        delete quote?.forms?.funding;
        delete quote?.forms?.paymentMethod;
        delete quote?.forms?.appointment;
        delete quote?.forms?.parentalControl;
        delete quote?.forms?.mrz;
        delete quote?.forms?.siren;
      }
      if (ProductFactory.Is(product, Phone)) {
        const quote = cartModel.getQuote(quoteIndex);
        delete quote?.forms?.portability;
        delete quote?.forms?.funding;
        delete quote?.forms?.paymentMethod;
        delete quote?.forms?.insurances;
        delete quote?.forms?.simCard;
      }
    }
    _checkCartValidity(cart) {
      const products = cart.getAllProducts();
      const gencodes = products.map(product => product.gencode);
      const obs = this.productRepo.getProductsByGencodes(gencodes).pipe(map(result => {
        return !result.some(product => {
          const currentProduct = products.find(productInCart => productInCart.gencode === product.gencode);
          return !this._isProductValid(product, currentProduct);
        });
      }), catchError(() => of(true)));
      return lastValueFrom(obs);
    }
    _isProductValid(product1, product2) {
      return product1.data.type_id === product2.data.type_id;
    }
    _handleAddToNonMixedCart(onlyAccessories, cartModel, productsToAdd, quotes, productToAddPMCompatible, newQuoteContextModel) {
      const [quote0, quote1] = quotes;
      const productAddedIsSameContext = new newQuoteContextModel().id === quote0.context.id;
      if (productAddedIsSameContext) {
        return this.addProducts(cartModel, productsToAdd, 0);
      }
      const isQuote0PmCompatible = !quote0.products?.some(p => ProductFactory.Is(p, Accessory) || ProductFactory.Is(p, Phone) || ProductFactory.Is(p, FaimUnlimited));
      const addToQuote1 = isQuote0PmCompatible && productToAddPMCompatible && quote0.products.length > 0 && !onlyAccessories;
      if (addToQuote1) {
        if (!quote1) {
          return of(this.addQuote(cartModel, new newQuoteContextModel())).pipe(mergeMap(() => this.addProducts(cartModel, productsToAdd, 1)));
        }
        if (quote1?.products?.length === 0) {
          return this.addProducts(cartModel, productsToAdd, 1);
        }
      } else {
        if (!onlyAccessories) {
          cartModel.quotes[0].context = new newQuoteContextModel();
        }
        if (quote1?.products && quote1?.products?.length === 0) {
          return this.removeQuote(cartModel, 1).pipe(concatMap(() => this.addProducts(cartModel, productsToAdd, 0)));
        }
        return this.addProducts(cartModel, productsToAdd, 0);
      }
    }
    _handleAddToCartWithAutoAdd(cartModel, productsToAdd) {
      return of(this.addQuote(cartModel, new QuoteContextFaiModel())).pipe(mergeMap(() => this.addProducts(cartModel, productsToAdd, 0)));
    }
    _handleAddToMixedCart(onlyAccessoriesAdded, cartModel, productsToAdd, quotes, productToAddPMCompatible, newQuoteContextModel) {
      if (onlyAccessoriesAdded) {
        return this.removeQuote(cartModel, 1).pipe(concatMap(() => this.removeQuote(cartModel, 0)), concatMap(() => this.addProducts(cartModel, productsToAdd, 0)));
      }
      if (productToAddPMCompatible) {
        const quoteToReplaceIndex = quotes.findIndex(quote => quote.context.id === new newQuoteContextModel().id);
        return this.addProducts(cartModel, productsToAdd, quoteToReplaceIndex);
      }
      return this.removeQuote(cartModel, 1).pipe(concatMap(() => this.removeQuote(cartModel, 0)), concatMap(() => this.addProducts(cartModel, productsToAdd, 0)), map(() => productsToAdd));
    }
    handleRenewContext(contractId, cartModel, productsToAdd, onlyAccessoriesOrOptionsAdded = false) {
      if (onlyAccessoriesOrOptionsAdded) {
        return this.addProducts(cartModel, productsToAdd, 0);
      }
      const renewQuoteContext = QuoteContextRenewalModel$1;
      const params = {
        contractId
      };
      const newCartModel = new CheckoutCartModel();
      this.refreshType(cartModel);
      this.save(cartModel);
      return this.setQuoteContext(newCartModel, renewQuoteContext, params).pipe(mergeMap(() => this.addProducts(newCartModel, productsToAdd, 0)));
    }
    deleteQuote(cartId, quoteId) {
      return this.oauth2Resource.ventes().panier(cartId).parcours(quoteId).setLocalService().useSalesApi().delete().pipe(catchError(error => {
        console.log(error);
        return of(true);
      }), map(() => true));
    }
    /**
     * Permet de supprimer les produits enfants autoadd déjà présent au panier
     * @param cartModel current cart model
     * @param products products to add
     * @param quoteIndex quote index
     * @returns observable<Product>
     */
    removeAutoAddProductObs(cartModel, products, quoteIndex = 0) {
      const currentQuote = cartModel.getQuote(quoteIndex);
      const productWithAutoAdd = products.find(p => p.autoAdd.find(gencode => currentQuote.getProductByGencode(gencode)));
      let removeObs = [];
      if (productWithAutoAdd) {
        const productsToRemove = [];
        productWithAutoAdd.autoAdd.forEach(gencode => productsToRemove.push(currentQuote.getProductByGencode(gencode)));
        productsToRemove?.filter(p => p && p.data.max_qty === 1)?.forEach(p => removeObs.push(this.removeProduct(cartModel, p, quoteIndex)));
      }
      return removeObs;
    }
    /**
     * Check if all products to add are compatible for a mixed cart
     * @param cartModel Current cart
     * @param productsToAdd Products to add
     * @param isFai current context is fai or not
     * @returns boolean
     */
    _isProductToAddPMCompatible(cartModel, productsToAdd, isFai) {
      const isFaiInFirstQuote = cartModel.getQuote(0).products.some(product => ProductFactory.Is(product, Fai));
      const isSowoOrSimo = productsToAdd.some(product => ProductFactory.Is(product, Sowo) || ProductFactory.Is(product, Simo));
      const productHasFaiSimoByouCategory = productsToAdd.some(product => product.categories.includes(OFFER_CATEGORY_CODE.FAI_SIMO) | product.categories.includes(OFFER_CATEGORY_CODE.FAI_BYOU));
      const hasPhoneProduct = productsToAdd.some(product => ProductFactory.Is(product, Phone));
      const productIsFaimUnlimited = productsToAdd.some(product => ProductFactory.Is(product, FaimUnlimited));
      return isFai && !productIsFaimUnlimited || (isFaiInFirstQuote ? productHasFaiSimoByouCategory : isSowoOrSimo) && !hasPhoneProduct;
    }
    static ɵfac = function CartCheckoutService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CartCheckoutService)(i0.ɵɵinject(PromotionRepository), i0.ɵɵinject(ProductRepository));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CartCheckoutService,
      factory: CartCheckoutService.ɵfac,
      providedIn: 'root'
    });
  }
  return CartCheckoutService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EdpService = /*#__PURE__*/(() => {
  class EdpService {
    cartService;
    oauth2Resource;
    static ALLOWED_PAYMENT_METHODS = {
      CASH: {
        label: 'Comptant',
        method: 'CASH'
      },
      SPREAD: {
        label: 'Facilité de paiement',
        method: 'SPREAD'
      }
    };
    subscription;
    equipment;
    constructor(cartService, oauth2Resource) {
      this.cartService = cartService;
      this.oauth2Resource = oauth2Resource;
    }
    get paymentMethods() {
      return Object.keys(EdpService.ALLOWED_PAYMENT_METHODS).map(key => EdpService.ALLOWED_PAYMENT_METHODS[key]);
    }
    hasEdp(cartModel) {
      // @todo handle all quotes ?
      return !!cartModel.getQuote().getProductByType('Edp');
    }
    addEdpProduct(cartModel, quoteIndex = cartModel.currentQuoteIndex) {
      const addEdp = new Edp({});
      return this.cartService.addProduct(cartModel, addEdp, quoteIndex).pipe(map(() => true));
    }
    removeEdpProduct(cartModel, quoteIndex = cartModel.currentQuoteIndex) {
      const edp = cartModel.getQuote(quoteIndex).getProductByType('Edp');
      return this.cartService.removeProduct(cartModel, edp, quoteIndex).pipe(map(() => true));
    }
    /**
     * @TODO Replace isEdpAllowed
     */
    isEdpAllowedNew(fundingMethods) {
      return fundingMethods?.some(fm => fm.type === FUNDING_ENUM.MULTI_PRODUCT);
    }
    // public get edp(cartModel: CheckoutCartModel, quoteIndex: number = cartModel.currentQuoteIndex): Edp {
    //     return cartModel.getQuote(quoteIndex).getProductByType<Edp>('Edp');
    // }
    checkEdpWithCoupon(cartModel, edp) {
      const coupon = cartModel.promotions.coupon;
      if (!this.isCouponCompatibleWithEdp(edp, coupon)) {
        return throwError({
          toAdd: edp,
          toDelete: coupon
        });
      } else {
        return of(edp);
      }
    }
    isCouponCompatibleWithEdp(edp, coupon) {
      return !edp || !coupon || coupon.isEligibleEdp;
    }
    static ɵfac = function EdpService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || EdpService)(i0.ɵɵinject(CartCheckoutService), i0.ɵɵinject(CheckoutOauth2ResourcesService));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: EdpService,
      factory: EdpService.ɵfac,
      providedIn: 'root'
    });
  }
  return EdpService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AddFundingService = /*#__PURE__*/(() => {
  class AddFundingService {
    fundingService;
    edpService;
    cartService;
    constructor(fundingService, edpService, cartService) {
      this.fundingService = fundingService;
      this.edpService = edpService;
      this.cartService = cartService;
    }
    setFundingDefaultValue(cartModel, fundingSelectedValue) {
      if (cartModel.isCartEmpty()) {
        return of(null);
      }
      let obs;
      // Insertion du produit EDP + appel tarification-sim
      if (fundingSelectedValue === FUNDING_ENUM.EDP) {
        obs = this.edpService.addEdpProduct(cartModel).pipe(map(() => true));
      } else {
        obs = of(true);
      }
      return obs.pipe(mergeMap$1(() => this._getFundingModes(cartModel)), mergeMap$1(({
        fundingMethods
      }) => {
        // Handle EDP case
        if (fundingSelectedValue === FUNDING_ENUM.EDP) {
          const edpFunding = fundingMethods.find(funding => funding.type === FUNDING_ENUM.MULTI_PRODUCT);
          // Si EDP ajouté mais pas modes de financement compatible
          if (!edpFunding) {
            return this.edpService.removeEdpProduct(cartModel).pipe(map(() => null));
          }
          return of(edpFunding);
        } else {
          return this.edpService.removeEdpProduct(cartModel).pipe(mergeMap$1(() => {
            if (fundingSelectedValue === FUNDING_ENUM.CASH) {
              return of(null);
            } else {
              return this._selectYounited(fundingMethods, fundingSelectedValue);
            }
          }));
        }
      }), mergeMap$1(funding => this.cartService.setFundingMethod(cartModel, funding)), mergeMap$1(() => this.cartService.refresh(cartModel)), map(() => true));
    }
    _selectYounited(fundingMethods, younitedSelected) {
      const funding = fundingMethods.find(fundingMethod => fundingMethod.type === FUNDING_ENUM.YOUNITED || fundingMethod.type === FUNDING_ENUM.SWAPPY);
      if (funding) {
        const match = younitedSelected.match(/^younited_x(\d+)$/i);
        const nbLoan = match ? Number(match[1]) : 24;
        this.fundingService.saveCreditChoice(nbLoan);
        return of(funding);
      }
      return of(null);
    }
    _getFundingModes(cartModel) {
      return cartModel.cartId ? this.fundingService.getFundingModes(cartModel) : this.fundingService.getVirtualFundingModes(cartModel);
    }
    static ɵfac = function AddFundingService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddFundingService)(i0.ɵɵinject(FundingService), i0.ɵɵinject(EdpService), i0.ɵɵinject(CartCheckoutService));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AddFundingService,
      factory: AddFundingService.ɵfac,
      providedIn: 'root'
    });
  }
  return AddFundingService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FakeCartService = /*#__PURE__*/(() => {
  class FakeCartService extends CartService {
    promotionRepo;
    productRepo;
    constructor(promotionRepo, productRepo) {
      super(promotionRepo, productRepo);
      this.promotionRepo = promotionRepo;
      this.productRepo = productRepo;
    }
    generateCart(quote) {
      const cartCheckout = new CheckoutCartModel();
      const phone = quote.getProductByType('Phone');
      if (phone) {
        return this.addProduct(cartCheckout, phone, 0, false).pipe(map(() => {
          // Default postal code for preorder
          cartCheckout.getQuote().address.shipping = {
            codePostal: '75000'
          };
          cartCheckout.getQuote().context = quote.isRenewal() ? new QuoteContextRenewalModel(quote.context.params) : new QuoteContextAcquisitionModel(quote.context.params);
          console.log(cartCheckout);
          return cartCheckout;
        }));
      }
      return of(cartCheckout);
    }
    static ɵfac = function FakeCartService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FakeCartService)(i0.ɵɵinject(PromotionRepository), i0.ɵɵinject(ProductRepository));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FakeCartService,
      factory: FakeCartService.ɵfac,
      providedIn: 'root'
    });
  }
  return FakeCartService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GcpService = /*#__PURE__*/(() => {
  class GcpService {
    oauth2ResourcesService;
    ACCEPTED_STATUS = ['0', '-1', '-10', '-200', '-201', '-202'];
    ORIGINEST = 'LABOUTIQUEBYTEL';
    constructor(oauth2ResourcesService) {
      this.oauth2ResourcesService = oauth2ResourcesService;
    }
    checkAddress(requestBody, address) {
      return this.oauth2ResourcesService.useSalesApi().ventes().gcp().addCache().post(requestBody).pipe(map(res => {
        const isControlValid = this.ACCEPTED_STATUS.includes(res.codeRetour.codeRetour);
        if (isControlValid) {
          address.codePostal = res.codePostal;
          address.ville = res.ville;
          address.rue = res.voie;
          address.numeroRue = res.numero;
        }
        address.isGcpValidated = isControlValid;
        return address;
      }), catchError(err => {
        console.error(err);
        address.isGcpValidated = false;
        address.isWaitingForConfirmation = true;
        return of(address);
      }));
    }
    static ɵfac = function GcpService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GcpService)(i0.ɵɵinject(CheckoutOauth2ResourcesService));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GcpService,
      factory: GcpService.ɵfac,
      providedIn: 'root'
    });
  }
  return GcpService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GraphQLService = /*#__PURE__*/(() => {
  class GraphQLService {
    config = inject(ConfigurationService);
    http = inject(HttpClient);
    document = inject(DOCUMENT);
    oauth2 = inject(Oauth2Service);
    query(body, scope) {
      const url = this.config.getData()?.global.graphQL.url;
      // Add generic headers :
      let headers = new HttpHeaders().set('X-Source', this.config.getData()?.oauth.xSource).set('Content-Type', 'application/json').set('X-Graphql-Scope', scope);
      if (this.oauth2.access_token) {
        headers = headers.append('Authorization', `Bearer ${this.oauth2.access_token}`);
      }
      return this.http.post(url, body, {
        headers
      });
    }
    static ɵfac = function GraphQLService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GraphQLService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GraphQLService,
      factory: GraphQLService.ɵfac,
      providedIn: 'root'
    });
  }
  return GraphQLService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of Checkout
 */
/* Modules */

/**
 * Generated bundle index. Do not edit.
 */

export { API_PROMO_TYPE, AddFundingService, AppointmentRepository, CART_TYPES, CONTRACT_STATUS, CONTRACT_TYPES, CUSTOMER_CATEGORY, CUSTOMER_TYPE, CartCheckoutService, CartRepository, CatalogRepository, CheckoutCartModel, CheckoutError, CheckoutModule, CheckoutOauth2ResourcesService, CheckoutStorageService, CommercialSeries, ConfigurationService, DISCOUNT_TYPE, DISPONIBILITY_SLOTS, DeliveryInfo, DeliveryService, EdpService, FUNDING_ENUM, FUNDING_METHODS_DETAILS, FUNDING_PRODUCT_ENUM, FaiRepository, FakeCartService, FundingCart, FundingMethod, FundingRepository, FundingService, GalliumService, GcpService, GraphQLService, LIGNE_MARCHE, LIMITED_RANGE, LINKED_API_PRODUCT_TYPE, LINKED_PRODUCT_TYPE, LimitedCommercialSeries, OPTION_STATUS, Oauth2Service, OptionsRepository, PAYMENT_MODE, PAYMENT_STATUS_ENUM, PRICES_CONTEXTS, PRICE_TYPES, PartnerError, PartnersService, ProductRepository, ProductService, PromotionRepository, QUOTE_CONTEXTS, QuoteContextFactory, QuoteContextRenewalModel, RangesNewGeneration, ReferrerService, SHIPPING_MODES$1 as SHIPPING_MODES, SOURCE_PROSPECT, STORAGE_TAGS, ScoringService, ShippingMethodModel, TYPE_LIGNE, UPDATE_ACTIONS, USER_TYPE_API, User, UserService, YAMA_STORAGE_KEY, dateSorter, frontFormatToApiVente, frontFormatToRefCliFormat, refCliFormatToFrontFormat };
